// +++++++++++++++++++++
// Check OS
// +++++++++++++++++++++
const checkOS = {
  init: function() {
    let OSName = null;

    if ( navigator.appVersion.indexOf("Win") != -1 ) OSName = 'Windows';
    if ( navigator.appVersion.indexOf("Mac") != -1 ) OSName = 'MacOS';
    if ( navigator.appVersion.indexOf("X11") != -1 ) OSName = 'UNIX';
    if ( navigator.appVersion.indexOf("Linux") != -1 ) OSName = 'Linux';

    $('body').addClass(OSName);
  }
}

// +++++++++++++++++++++
// Check Browser
// +++++++++++++++++++++
const checkBrowser = {
  init: function() {
    var isFirefox = typeof InstallTrigger !== 'undefined';
    var isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));
    var isIE = /*@cc_on!@*/false || !!document.documentMode;
    var isEdge = !isIE && !!window.StyleMedia;
    var isChrome = !!window.chrome && (!!window.chrome.webstore || !!window.chrome.runtime);

    if (isFirefox) {
      $('body').addClass('firefox');
    } else if (isSafari) {
      $('body').addClass('safari');
    } else if (isIE) {
      $('body').addClass('ie');
    } else if (isEdge) {
      $('body').addClass('edge');
    } else if (isChrome) {
      $('body').addClass('chrome');
    }
  }
};

// +++++++++++++++++++++
// Global Variables
// +++++++++++++++++++++
function setGlobalVariables() {
  window.addEventListener('resize', updateGlobalVariables)
  updateGlobalVariables()
}

function updateGlobalVariables() {
  // Used for things like popups, drawers, etc. that need to be constrained within the viewable portion of a scroll-locked window

  setHeight({ selector: 'nav.navigation', property: '--nav-height' })
  setHeight({ selector: '.announcement--section', property: '--bar-height' })
}

function setHeight({ selector, property }) {
  const element = document.querySelector(selector)
  const height = element?.offsetHeight || 0

  document.body.style.setProperty(property, `${height}px`)
}

setGlobalVariables()


// +++++++++++++++++++++
// AA: Helper Functions & variables
// +++++++++++++++++++++
var isMobile = function(){
  return window.screen.availWidth < 960;
}

var formatMoney = function(cents, format) {
  if (typeof cents == 'string') { cents = cents.replace('.',''); }
  var value = '';
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = (format || this.money_format);

  function defaultOption(opt, def) {
     return (typeof opt == 'undefined' ? def : opt);
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ',');
    decimal   = defaultOption(decimal, '.');

    if (isNaN(number) || number == null) { return 0; }

    number = (number/100.0).toFixed(precision);

    var parts   = number.split('.'),
        dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
        cents   = parts[1] ? (decimal + parts[1]) : '';

    return dollars + cents;
  }

  switch(formatString.match(placeholderRegex)[1]) {
    case 'amount':
      value = formatWithDelimiters(cents, 2);
      break;
    case 'amount_no_decimals':
      value = formatWithDelimiters(cents, 0);
      break;
    case 'amount_with_comma_separator':
      value = formatWithDelimiters(cents, 2, '.', ',');
      break;
    case 'amount_no_decimals_with_comma_separator':
      value = formatWithDelimiters(cents, 0, '.', ',');
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

var addNoScroll = function(){
  $(document.body).addClass('no-scroll');
}

var removeNoScroll = function(){
  $(document.body).removeClass('no-scroll');
}

$.fn.watchFor = function(child, callback) {
  const parent = this[0];

  const observer = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
          mutation.addedNodes.forEach(function(addedNode) {
              const $foundNodes = $(addedNode).find(child);

              if ( $foundNodes.length && callback ) callback($foundNodes);
          });
      });
  });
  observer.observe(parent, { subtree: true, childList: true });

  if ( callback ) callback($(child));

  return this;
};

$.fn.watchForChild = function(parent, callback) {
  const observer = new MutationObserver(function(mutationsList) {
      mutationsList.forEach(function(mutation) {
        if (mutation.type === 'childList') {
          // console.log('A child node has been added or removed.');
          if ( callback ) callback($(parent));
        } 
      });
  });
  observer.observe(parent, { subtree: true, childList: true });

  // if ( callback ) callback($(parent));

  return this;
};
// +++++++++++++++++++++
// JA: Navigation Module
// +++++++++++++++++++++
const navigation = {
  settings: {
    topPadding: 75,
    navWrapper: '.nav-wrapper',
    nav: 'nav'
  },

  init: function() {
    this.scrollTop = 0;

    this.initEventListeners();
    this.checkPage();
  },

  initEventListeners: function() {
    $(document).on('scroll', () => this.handleScroll());
  },

  getEl: function() {
    const { navWrapper, nav } = this.settings;
    return $(navWrapper + ' ' + nav);
  },

  checkPage: function() {
    const $topSection = $('main .shopify-section section').first();
    const $nav = this.getEl();

    if ( $topSection.data('nav-color') ) {
      $nav.addClass('light');
    } else {
      $nav.removeClass('light');
    }
  },

  handleScroll: function() {
    const $nav = this.getEl();

    if ( this.isPastPadding() ) {
      // Check if scrolling down
      if ( window.scrollY > this.scrollTop ) {
        this.hide($nav);

      } else {
        this.show($nav);
        this.solidify($nav);
      }

    } else {
      this.show($nav);
      this.clearify($nav);
    }

    this.scrollTop = window.scrollY <= 0 ? 0 : window.scrollY;
  },

  isPastPadding: function() {
    return window.scrollY >= this.settings.topPadding;
  },

  show: function($nav) {
    $nav.addClass('active');
  },

  hide: function($nav) {
    $nav.removeClass('active');
  },

  clearify: function($nav) {
    $nav.removeClass('solid');
  },

  solidify: function($nav) {
    $nav.addClass('solid');
  }
};


/** 
 * --------------------------------
 * Desktop Hover Mega Menu 
 * --------------------------------
*/
function hoverMegaMenu({ wrapper }) {
  // wrapper = desktop trigger link  
  const referenceLink = $(wrapper).data('link')

  const selectors = {
    target: `.js-mega-menu[data-link="${ referenceLink }"]`,
    triggers: wrapper,
  }

  const cache = {
    $targets: $(selectors.target),
    $triggers: $(selectors.triggers),
  }

  const state = {
    mouseIsWithinRelatedElements: false,
  }

  ;(function initEventListeners() {
    if (cache.$targets.length === 0) return;

    $(wrapper).on('mouseenter focus click', openOnHover)
    $(wrapper).on('blur', closeOnMouseleave)

    cache.$targets.on('mouseleave', closeOnMouseleave)
    cache.$triggers.on('mouseleave', closeOnMouseleave)

    cache.$targets.on('mouseenter', function (event) {
      state.mouseIsWithinRelatedElements = true
    })

    cache.$triggers.on('mouseenter', function (event) {
      state.mouseIsWithinRelatedElements = true
    })
  })()

  function openOnHover() {
    // console.log('hoverToggle / openOnHover')

    cache.$targets.addClass('active')
    cache.$triggers.addClass('active')
  }

  function closeOnMouseleave(event) {
    // console.log('hoverToggle / closeOnMouseleave')

    // updated to be within any triggers and any target
    const isWithinTrigger = !!$(event.relatedTarget).closest(cache.$triggers).length
    const isWithinTarget = !!$(event.relatedTarget).closest(cache.$targets).length

    state.mouseIsWithinRelatedElements = isWithinTrigger || isWithinTarget

    setTimeout(() => {
      if (!state.mouseIsWithinRelatedElements) {
        close()
      }
    }, 300)
  }

  function close() {
    // console.log('hoverToggle / close')

    cache.$targets.removeClass('active')
    cache.$triggers.removeClass('active')
  }
}

// +++++++++++++++++++++
// JA: Mega Menu Module
// +++++++++++++++++++++
const megamenu = {
  settings: {
    desktopLinks: '.js-mega-link',
    mobileLinks: '.js-mobile-link',
    megamenu: '.js-mega-menu',
    overlay: '.js-overlay',
    closeButton: '.js-mega-menu-close',
    closeSelfButton: '.js-mega-menu-close-self',
    accountMenu: '.js-account-nav',
  },

  init: function() {
    this.initEventListeners();
  },

  initEventListeners: function() {
    const { desktopLinks, mobileLinks, closeButton, closeSelfButton, megamenu, overlay, accountMenu } = this.settings;
    $(mobileLinks).on('click', (e) => this.handleClick(e));
    // $(desktopLinks).on('mouseenter', (e) => this.handleClick(e));

    $(desktopLinks).each((index, link) => {
      hoverMegaMenu({ wrapper: link })
    })

    $(accountMenu).on('click', (e) => this.handleAccountClick(e));
    $(overlay).on('click', () => this.closeAll());
    $(megamenu).on('focusout', (e) => this.handleBlur(e));
    $(closeButton + ', ' + closeSelfButton).on('click', (e) => this.handleClose(e));
  },

  handleClick: function(e) {
    // link that we're hovering over
    let $trigger = $(e.target);
    
    if ( !$trigger.is('a') ) {
      $trigger = $trigger.closest('a');
    }

    // mega menu that is relevant
    const $relatedMenu = this.getRelatedMenu($trigger);

    if ( $relatedMenu ) {
      e.preventDefault();

      if ( !this.isMenuOpen($relatedMenu) ) {
        if ( !this.isSubMenu($relatedMenu) ) {
          this.closeAll();
        }
        this.openMenu($relatedMenu, $trigger);
        // $(this.settings.clickLinks).fadeOut(300)
        //$(this.settings.megamenu).scrollTop(0)
        // $(this.settings.clickLinks).fadeIn(300)

      } else {
        if ( !this.isSubMenu($relatedMenu) ) {
          this.closeAll();
        } else {
          this.closeMenu($relatedMenu, $trigger);
        }
      }
    }
  },

  handleAccountClick: function(e) {
    let $trigger = $(e.target);

    if ( !$trigger.is('a') ) {
      $trigger = $trigger.closest('a');
    }

    const $relatedMenu = this.getRelatedMenu($trigger);

    if ( $relatedMenu ) {
      e.preventDefault();

      if ( !this.isMenuOpen($relatedMenu) ) {
        if ( !this.isSubMenu($relatedMenu) ) {
          this.closeAll();
        }
        this.openMenu($relatedMenu, $trigger);
        addNoScroll();
      } else {
        if ( !this.isSubMenu($relatedMenu) ) {
          this.closeAll();
        } else {
          this.closeMenu($relatedMenu, $trigger);
          removeNoScroll();
        }
      }
  }
  },
  handleBlur: function(e) {
    const { currentTarget, relatedTarget } = e;
    const $menu = $(currentTarget);

    if ( $.contains(currentTarget, relatedTarget) ) { return; }
    if ( $menu.data('link') == $(relatedTarget).data('link') ) { return; }
    if ( relatedTarget == null ) {
      console.warn('Warning: event.relatedTarget not found');
      return;
    }

    const dataLink = $menu.data('link');
    const $trigger = $(`${ this.settings.desktopLinks }[data-link="${ dataLink }"]`);

    this.closeMenu($menu, $trigger);
  },

  handleClose: function(e) {
    e.preventDefault();
    let $trigger = $(e.target);

    if ( !$trigger.is('a') ) {
      $trigger = $trigger.closest('a');
    }

    if ( $trigger.hasClass('js-mega-menu-close-self') ) {
      const $menu = $trigger.closest('.js-mega-menu');
      this.closeMenu($menu);
    } else {
      this.closeAll();
    }

  },

  getRelatedMenu: function($trigger) {
    const menuReference = $trigger.data('link');
    const $relatedMenu = $(`.js-mega-menu[data-link="${ menuReference }"]`);

    if ( $relatedMenu.length ) {
      return $relatedMenu;
    }
  },

  isSubMenu: function($menu) {
    return !$menu.hasClass('mega-menu');
  },

  isMenuOpen: function($menu) {
    return $menu.hasClass('active');
  },

  openMenu: function($menu, $trigger) {
    $menu.addClass('active');
    $trigger.addClass('active');

    this.addTabindex($menu);

    if (isMobile()) {
      addNoScroll();
    }
    $(this.settings.megamenu).scrollTop(0)
    // $('.mega-menu').fadeOut(300)
    // $('.sub-menu').fadeIn(300)

  },

  closeMenu: function($menu, $trigger = null) {
    $menu.removeClass('active');

    if ( $trigger ) {
      $trigger.removeClass('active');
    }

    this.removeTabindex($menu);
  },

  closeAll: function() {
    const t = this;

    $('.js-mega-menu').each(function() {
      const $menu = $(this);
      t.closeMenu($menu);
    });

    // Reset all triggers
    $(this.settings.desktopLinks).each(function() {
      const $trigger = $(this);
      $trigger.removeClass('active');
    });

     // Reset all triggers
     $(this.settings.mobileLinks).each(function() {
      const $trigger = $(this);
      $trigger.removeClass('active');
    });

    removeNoScroll();
  },

  addTabindex: function($menu) {
    $menu.find('> ul > li > a').each(function() {
      $(this).attr('tabindex', '0');
    });
  },

  removeTabindex: function($menu) {
    $menu.find('a').each(function() {
      $(this).attr('tabindex', '-1');
    });
  }
}

// +++++++++++++++++++++
// SS: Slick Sliders
// +++++++++++++++++++++
var slickSliders = (function() {
  var settings = {
    dataAttr: 'data-slider',
    fullWidth: 'full-width',
    mobileOnly: 'mobile-only',
    trailingSlide: '.trailing'
  };

  var init = function() {
    const { dataAttr, fullWidth, mobileOnly, trailingSlide } = settings;
    const $sliders = $(`[${ dataAttr }]`);
    if ( !$sliders.length ) { return; }

    $sliders.each(function() {
      const $slider = $(this);

      switch ($slider.attr(dataAttr)) {
        case fullWidth:
          const fullWidthArrows = {
            prevArrow: $slider.siblings('.slick-arrow.slick-prev'),
            nextArrow: $slider.siblings('.slick-arrow.slick-next')
          };
          $slider.slick({...fullWidthArrows, ...fullWidthSliderSettings});
          break;

        case 'slider1':
          const slider1Arrows = {
            prevArrow: $slider.siblings('.slick-arrow.slick-prev'),
            nextArrow: $slider.siblings('.slick-arrow.slick-next')
          };
          $slider.slick({...slider1Arrows, ...slider1Settings});
          break;

        case 'slider2':
          const slider2Arrows = {
            prevArrow: $slider.siblings('.slick-arrow.slick-prev'),
            nextArrow: $slider.siblings('.slick-arrow.slick-next')
          };

          $slider.slick({...slider2Arrows, ...slider2Settings});
          break;

        case 'product-images':
            $slider.slick(productImageSettings);

          break;

        case 'product-images-controller':
          $slider.slick(productImageControllerSettings);
          break;

        case 'page-slideshow':
            const slideshowArrows = {
              prevArrow: $slider.siblings('.slick-arrow.slick-prev'),
              nextArrow: $slider.siblings('.slick-arrow.slick-next')
            };
            $slider.slick({ ...slideshowArrows, ...pageSlideshowSettings });
          break;
        case 'landing-page-collection':
            const landingCollectionArrows = {
              prevArrow: $slider.siblings('.slick-arrow.slick-prev'),
              nextArrow: $slider.siblings('.slick-arrow.slick-next')
            };
            $slider.slick({ ...landingCollectionArrows, ...collectionSliderSettings });
          break;
        case mobileOnly:
          const mobileOnlyArrows = {
            prevArrow: $slider.siblings('.btn-wrapper').find('.slick-arrow.slick-prev'),
            nextArrow: $slider.siblings('.btn-wrapper').find('.slick-arrow.slick-next')
          };

          $(window).on('resize', function(){
            handleResize($slider, {...mobileOnlyArrows, ...mobileOnlySettings }, 768);
          });

          handleResize($slider, {...mobileOnlyArrows, ...mobileOnlySettings }, 768);

          break;

        default:
          $slider.slick(generalSliderSettings);
          break;
      }

      const $trailingSlide = $slider.find(trailingSlide);

      if ( !$trailingSlide.length ) { return; }

      var observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutationRecord) {
          if ( $(mutationRecord.target).css('display') == 'none' ) { return; }

          const $slide = $(mutationRecord.target);
          $slide.height($slide.width());
        });
      });

      $trailingSlide.each(function() {
        const $slide = $(this);

        observer.observe($slide[0], { attributes : true, attributeFilter : ['style'] });
        $slide.height($slide.width());
      });
    });
  }

  function handleResize(slider, settings, maxWidth) {
    if ( $(window).outerWidth() >= maxWidth ) {
      if ( slider.hasClass('slick-initialized') ) {
        slider.slick('unslick');
      }
    } else {
      if (!slider.hasClass('slick-initialized') ) {
        slider.slick(settings);
      }
    }
  };

  var generalSliderSettings = {
    arrows: false,
    autoplay: true,
    autoplaySpeed: 2000,
    centerMode: true,
    mobileFirst: true,
    slidesToScroll: 1,
    slidesToShow: 3,
    variableWidth: true,
    responsive: [
     {
        breakpoint: 767,
        settings: "unslick"
     },
     {
        breakpoint: 500,
        settings: {
          slidesToShow: 5,
          slidesToScroll: 1
        }
      }
    ]
  }

  var collectionSliderSettings = {
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    dots: false,
    infinite: false,
    adaptiveHeight: true,
    centerPadding: '2px',
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1301,
        settings: {
          slidesToShow: 4,
          infinite: false
        }
      },
      {
        breakpoint: 1300,
        settings: {
          slidesToShow: 3,
        }
      },
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1
        }
      }
    ]
  }

  var productImageSettings = {
    autoplay: false,
    dots: true,
    nextArrow: '<button class="icon icon-arrow slick-arrow slick-next" aria-label="Next" type="button"></button>',
    prevArrow: '<button class="icon icon-arrow slick-arrow slick-prev" aria-label="Previous" type="button"></button>',
    slidesToScroll: 1,
    slidesToShow: 1
  }

  var productImageControllerSettings = {
    arrows: false,
    asNavFor: '[data-slider="product-images"]',
    focusOnSelect: true,
    slidesToScroll: 1,
    slidesToShow: $('[data-slider="product-images-controller"]').children().length,
    swipeToSlide: true, 
    variableWidth: false
  }

  var pageSlideshowSettings = {
    arrows: true,
    autoplay: false,
    dots: true,
    slidesToScroll: 1,
    adaptiveHeight: true,
    slidesToShow: 1
  }

  var fullWidthSliderSettings = {
    arrows: true,
    dots: true,
    fade: true,
    slidesToScroll: 1,
    slidesToShow: 1
  }

  var mobileOnlySettings = {
    arrows: true,
    dots: true,
    autoplay: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 1
  };

  var slider1Settings = {
    arrows: true,
    autoplay: false,
    infinite: false,
    mobileFirst: true,
    slidesToScroll: 1,
    slidesToShow: 1,
    responsive: [
     {
        breakpoint: 768 - 1,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      }
    ]
  };

  var slider2Settings = {
    arrows: true,
    dots: true,
    autoplay: false,
    infinite: false,
    slidesToScroll: 1,
    slidesToShow: 1,
    mobileFirst: true,
    responsive: [
      {
        breakpoint: 1050,
        settings: {
          slidesToShow: 4,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1
        }
      },
      {
        breakpoint: 500,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1
        }
      }
    ]
  };

  return {
    init: init
  }
})();

// +++++++++++++++++++++
// Popup Generator
// +++++++++++++++++++++
const popupGenerator = {
  settings: {
    dataAttr: 'data-popup',
    video: 'video'
  },

  init: function() {
    const { dataAttr, video } = this.settings;

    const $videoPopup = $(`[${ dataAttr }="${ video }"]`);

    if ( !$videoPopup.length ) { return; }

    $videoPopup.each(function() {
      const $link = $(this);

      // Get video URL
      const url = $link.attr('href');

      // Convert URL to embed link
      const splitURL = url.split('watch?v=');
      const embedURL = splitURL[0] + 'embed/' + splitURL[1];

      // Create modal & iframe
      const $popup = $('<div class="popup hide"></div>');
      const $modal = $('<div class="modal"></div>');
      const $wrapper = $('<div class="iframe-wrapper"></div>');
      const $iframe = $('<iframe title="YouTube video player" frameborder="0" allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');

      $iframe.attr('src', embedURL);
      $wrapper.append($iframe);
      $modal.append($wrapper);
      $popup.append($modal);

      $('body').append($popup);

      $popup.on('click', function(e) {
        $popup.addClass('hide');
        $modal.removeClass('active');

        // Stop video
        $iframe.attr('src', $iframe.attr('src'));
      });

      $link.on('click', function(e) {
        e.preventDefault();
        $popup.removeClass('hide');
        $modal.addClass('active');
      })
    });
  }
}

// +++++++++++++++++++++
// Inline Video
// +++++++++++++++++++++
const inlineVideo = {
  settings: {

  },

  init: function() {
    const $triggers = $('[data-inline-video]');
    const inlineVideo = this;

    if ( !$triggers.length ) { return; }

    $triggers.each(function() {
      const $trigger = $(this);
      const videoType = $trigger.data('inline-video');
      const videoURL = $trigger.attr('href');

      switch (videoType) {
        case 'youtube':
          inlineVideo.loadYouTube(videoURL, $trigger);
          break;

        default:
          console.error('Error: videoType "' + videoType + '" not recognized');
          break;
      }
    });
  },

  loadYouTube: function(videoURL, $trigger) {
    const inlineVideo = this;

    // Load the IFrame Player API
    $.getScript("https://www.youtube.com/iframe_api", function() {
      inlineVideo.createYouTubeIframe(videoURL, $trigger);
    });
  },

  createYouTubeIframe: function(videoURL, $trigger) {
    const inlineVideo = this;
    const videoID = videoURL.split('watch?v=')[1];

    let player;
    window.YT.ready(function() {
      player = new window.YT.Player(videoURL, {
        height: "390",
        width: "640",
        videoId: videoID,
        events: {
          onReady: playerReady
        }
      });
    });

    function playerReady(e) {
      inlineVideo.initYouTubeEventListeners(e.target);
    }
  },

  initYouTubeEventListeners: function(player) {
    const $player = $(player.h);
    const playerID = $player.attr('id');
    const $trigger = $player.parents(`[href="${ playerID }"]`);

    $trigger.on('click', function(e) {
      e.preventDefault();

      $(this).find('.iframe-cover').removeClass('active');
      player.playVideo();
    })
  }
};

// +++++++++++++++++++++
// Marquee
// +++++++++++++++++++++
const marquee = {
  settings: {
    marquee: '.js-marquee',
    inner: '.js-marquee-inner',
    responsiveClass: 'js-marquee-responsive',
    initializedClass: 'marquee-initialized'
  },

  init: function() {
    this.initializeObjects();
    this.initializeAll();
  },

  initializeObjects: function() { // create an object for each marquee
    this.all = {};
    const marquee = this;

    $(this.settings.marquee).each(function(i) {
      $(this).attr('data-marquee', i);
      const ID = 'marquee' + i;

      const contentQuantity = $(this).find(marquee.settings.inner + ' > *').length;
      const marqueeWidth = $(this).find(marquee.settings.inner)[0].scrollWidth;

      const obj = {
        animationFrame: null,
        allowedLength: contentQuantity - 1,
        width: marqueeWidth
      };

      marquee.all[ID] = obj;
    });
  },

  getObject: function($marquee) {
    const ID = $marquee.data('marquee');
    return this.all['marquee' + ID];
  },

  initializeAll: function() { // check for responsiveness setting
    const marquee = this;

    $(this.settings.marquee).each(function() {
      const $marquee = $(this);

      if ( $marquee.hasClass(marquee.settings.responsiveClass) ) {
        marquee.alert($marquee);
      } else {
        marquee.trigger($marquee);
      }
    })
  },

  alert: function($marquee) { // trigger/kill, dependant on screen size/resize
    $(window).on('resize', () => this.handleResize($marquee));
    this.handleResize($marquee);
  },

  handleResize: function($marquee) {
    const selfObj = this.getObject($marquee);

    if ( selfObj.width >= $(window).width() ) {
      this.trigger($marquee);
    } else {
      this.kill($marquee);
    }
  },

  trigger: function($marquee) {
    if ( $marquee.hasClass(this.settings.initializedClass) ) { return; }

    // Settings
    let speed = 1;

    const selfObj = this.getObject($marquee);
    const $inner = $marquee.find(this.settings.inner);
    const $content = $marquee.find(this.settings.inner + ' > *');

    // Duplicate content
    const $clone = $content.clone();
    $clone.appendTo($inner);

    let progress = 1;

    function loop() {
      progress = progress - speed;
      if ( progress <= selfObj.width * -1 ) {
        progress = 0;
      }

      $inner.css({ transform: `translateX(${ progress }px)` });

      selfObj.animationFrame = window.requestAnimationFrame(loop);
    }
    loop();

    $marquee.addClass(this.settings.initializedClass);
  },

  kill: function($marquee) { // Turn off marquee animation
    if ( !$marquee.hasClass(this.settings.initializedClass) ) { return; }

    const selfObj = this.getObject($marquee);
    window.cancelAnimationFrame(selfObj.animationFrame);

    this.cleanUp($marquee);
  },

  cleanUp: function($marquee) {
    const selfObj = this.getObject($marquee);
    const $inner = $marquee.find(this.settings.inner);

    // remove cloned nodes
    $inner.children().each(function(i) {
      if ( i > selfObj.allowedLength ) {
        $(this).remove();
      }
    });

    // reset affected elements
    $marquee.removeClass(this.settings.initializedClass);
    $inner.css({ 'transform': 'none' });
  }
}

// +++++++++++++++++++++
// SS: Accessibility
// +++++++++++++++++++++
var accessibility = (function(){
  var settings = {
    focusObject: ".focus-accessible"
  }

  var init = function(){
    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    //Accessibility for opaque buttons
    $(settings.focusObject).on("focus", focusOn)
    $(settings.focusObject).on("blur", focusOn)
  }

  var focusOn = (function(){
    $(this).parent('.focus-parent').addClass('focus-visible');
  });

  return {
    init: init
  }
})();

// +++++++++++++++++++++
// Cart
// +++++++++++++++++++++
var cart = (function(){
  var settings = {
    activeClass: "active",
    overlay: ".js-overlay",
    addToCart: "[action='/cart/add']",
    cartContainer: ".js-cart-container",
    cartLink: ".js-cart",
    moneyFormat: "${{ amount }}",
    closeCart: ".js-close-cart",
    cartRemove: ".js-remove-item",
    qtyAdjusters: ".js-adjust-qty",
    itemQty: ".js-item-qty",
    cartItems: ".js-cart-items",
    cartCount: ".js-cart-count",
    checkoutButton: '.js-process-checkout',
    rechargeItems: ".js-recharge-item",
    cartNoteCheckbox: ".js-cart-note-toggle",
    cartNoteText: ".js-cart-note",
    recommendationScript: "#recommendation-json"
  }

  var recommendations, donation;

  var init = function(){
    var $section = $(settings.cartContainer);

    if (!$section.length) {
      return;
    }

    initializeEventListeners();
    loadProductRecommendations();
    getCart();
  }

  var initializeEventListeners = function(){
    $(document).on('submit', settings.addToCart, addToCart);
    $(settings.cartLink).on('click', openCart);
    $(document).on('click', settings.cartRemove, adjustItemQuantity);
    $(document).on('click', settings.qtyAdjusters, adjustItemQuantity);
    $(document).on('change', settings.itemQty, adjustItemQuantity);
    $(document).on('click', settings.overlay + ", " + settings.closeCart,  closeCart);
    $(document).on('click', settings.checkoutButton, processCart);
    $(document).on('change', settings.cartNoteCheckbox, toggleCartNote);
    $(document).on('change', settings.cartNoteText, updateCartNote);
  }

  var loadProductRecommendations = function(){
    var $script = $(settings.recommendationScript);

    json = JSON.parse($script.html());

    recommendations = json.products.map((product) => JSON.parse(product));

    donation = json.donation;
  }

  var getRecommendedProduct = function(cart){
    var cartProductIds = cart.items.reduce(function(accumulator, item){
      accumulator.push(item.product_id)
      return accumulator
    },[])

    return recommendations.find(function(rec){
      return !cartProductIds.includes(rec.id)
    })
  }

  var processCart = function(e){
    if ($(settings.rechargeItems).length) {
      var url = reChargeProcessCart()
      location.href = url
    } else {
      e.preventDefault();
      getCart(function(cart){
        let totalStackCount = 0;

        cart.items.forEach(item => {
          if (item.properties && item.properties._earStack) {
            totalStackCount += item.quantity;
          }
        })

        if (totalStackCount > 1) {
          location.pathname = '/checkout?discount=EarStack';
        } else {
          location.pathname = '/checkout';
        }
      }).catch(function(err){
        location.pathname = '/checkout';
      });
    }
  }

  var toggleCartNote = function(e){
    var $cartNoteText = $(settings.cartNoteText);
    if ($cartNoteText.hasClass('active')) {
      $(settings.cartNoteText).val('').change();
    }
    $cartNoteText.toggleClass('active');
  }

  var updateCartNote = function(e){
    var $this = $(this);

    var note = $this.val();

    var params = {
      url: "/cart/update.js",
      data: { note: note },
      dataType: "json",
      success: function(cart){
        // buildCart(cart);
      }
    }
    $.ajax(params);
  }

  var updateCartCount = function(cart){
    var $cartIcon = $('.js-cart');

    if (cart.item_count === 0) {
      $cartIcon.removeClass("active")
    } else {
      $cartIcon.addClass("active")
    }
  }

  var getCart = function(callback){
    var params = {
      url: "/cart.js",
      dataType: "json",
      success: function(cart){
        if (callback) {
          callback(cart);
        } else {
          buildCart(cart);
        }
      }
    }

    $.ajax(params)
  }





  var onCartUpdate = function(){
    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004132660"
      }
    });

    /*window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004128786" // replace with the target location ID
      }
    });

    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004127749" // replace with the target location ID
      }
    });*/

    console.log('🛒 Carrito abierto por agregar producto al carrito');

    getCart();
    openCart();
  }

  var changeCart = function(data, callback){
    var params = {
      url: "/cart/change.js",
      data: data,
      dataType: "json",
      success: function(cart){
        if (callback) {
          callback(cart);
        } else {
          buildCart(cart);
        }
      }
    }
    $.ajax(params);
  }

  var addToCart = function(e){
    e.preventDefault();

    var body = $(this).serialize();

    var params = {
      url: "/cart/add.js",
      dataType: "json",
      data: body,
      method: "POST",
      success: function(item){
        onCartUpdate();

        if ($(".js-quickshop-close").length) {
          $(".js-quickshop-close").click();
        }

      }
    }

    $.ajax(params);
  }

  var adjustItemQuantity = function(e){
    e.preventDefault();
    e.stopPropagation();

    var $this = $(this)
    if ($this.val()) {
      var quantity = $this.val()
    } else {
      var quantity = $this.data('qty');
    }
    var key = $this.data('key')

    var data = {
      id: key,
      quantity: quantity
    }
    changeCart(data)
  }

  var openCart = function(e){
    /*window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004115999"
      }
    });*/

    window._conv_q = window._conv_q || [];
    window._conv_q.push({
      what: "triggerLocation",
      params: {
        locationId: "1004132660"
      }
    });

    /*function refreshCartM() {
      fetch('/cart.js')
      .then(res => res.json())
      .then(updatedCart => {
        buildCart(updatedCart);

        setTimeout(function() {
          buildCart(updatedCart);
        }, 200);
      })
      .catch(console.error);
    }

    refreshCartM();
*/
    function setCookie(name, value, days) {
      let expires = "";
      if (days) {
        const date = new Date();
        date.setTime(date.getTime() + days*24*60*60*1000);
        expires = "; expires=" + date.toUTCString();
      }
      document.cookie = name + "=" + (value || "")  + expires + "; path=/";
    }

    function getCookie(name) {
      const nameEQ = name + "=";
      const ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) === " ") c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) === 0) return c.substring(nameEQ.length, c.length);
      }
      return null;
    }

    if (!getCookie("opened_cart")) {
      setCookie("opened_cart", "true", 7);
      window._conv_q = window._conv_q || [];
      _conv_q.push(["triggerConversion", "1004106276"]);
    }
    
    if (e) {
      e.preventDefault();
    }

    console.log('🛒 Carrito abierto por clic en icono del carrito');
    
    var $cartContainer = $(settings.cartContainer);
    $cartContainer.addClass(settings.activeClass);
    var overlay = $(settings.overlay).not(".js-mega-menu .js-overlay");
    overlay.css({
      top: 0
    });
    overlay.addClass([settings.activeClass, "cart-overlay"]);
    addNoScroll();
  }

  var closeCart = function(){
    var $cartContainer = $(settings.cartContainer);
    $cartContainer.removeClass(settings.activeClass);
    var overlay = $(settings.overlay);
    if (overlay.hasClass("wishlist-overlay")) {
      overlay.removeClass(["cart-overlay"]);
    } else {
      overlay.removeClass([settings.activeClass, "cart-overlay"]);
    }
    removeNoScroll();
  }

  function hasFreeShipping(cart, shippingThreshold){
    return shippingThreshold <= cart.total_price // true or false depending on amounts
  }

  function getShippingProgress(cart, shippingThreshold){
    if (hasFreeShipping(cart, shippingThreshold)) return '100%';

    let percentage = parseInt(cart.total_price / shippingThreshold * 100);
    return `${percentage}%` // '50%'
  }

  function getShippingMessage(cart, shippingThreshold){
    if (hasFreeShipping(cart, shippingThreshold)) {
      return 'You’ve earned free standard US shipping!';
    } else if (cart.total_price === 0) {
      // replace $59 with shippingThreshold formatted
      const formattedThreshold = formatMoney(shippingThreshold, '${{ amount_no_decimals }}');
      return `Enjoy free standard US shipping with orders over ${formattedThreshold}!`;
    } else {
      // replace $25 with calculated amount
      const amountToFreeShipping = formatMoney((shippingThreshold - cart.total_price), '${{ amount_no_decimals }}');
      return `You’re <b>${amountToFreeShipping}</b> away from free standard US shipping!`;
    }
  }

  var buildCart = function(cart){
    updateCartCount(cart);

    var $cartContainer = $(settings.cartItems);
    $cartContainer.empty();

    var recommendedProduct = getRecommendedProduct(cart);

    var items = []
    var item = {}
    var data = {}
    var source = $("#CartTemplate").html()
    var template = Handlebars.compile(source);
    let totalStackCount = 0;
    let totalSavings = 0;
    let setTotalSavings = 0;

    $.each(cart.items, function(index, cartItem) {
      var prodImg = {}
      let isFinalSale = false;

      if (cartItem.image != null){
        prodImg.src = cartItem.image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
        prodImg.dataSrc = cartItem.image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
      } else {
        var prodImg = "//cdn.shopify.com/s/assets/admin/no-image-medium-cc9732cb976dd349a0df1d39816fbcc7.gif";
      }

      if (cartItem.properties && cartItem.properties.shipping_interval_frequency) {
        if (parseInt(cartItem.properties.shipping_interval_frequency) === 1) {
          var rechargeProperties = "Ships every " + cartItem.properties.shipping_interval_frequency + " " + cartItem.properties.shipping_interval_unit_type.replace('s', '').toLowerCase();
        } else {
          var rechargeProperties = "Ships every " + cartItem.properties.shipping_interval_frequency + " " + cartItem.properties.shipping_interval_unit_type
        }
      } else {
        var rechargeProperties = null
      }

      if (cartItem.properties && cartItem.properties._earStack) {
        totalStackCount += cartItem.quantity;
      }

      if (cartItem.properties && cartItem.properties._finalSale) {
        isFinalSale = true
      }

      var comparePrice = "";
      let savingPrice = "";


      if (cartItem.final_price < cartItem.price) {
        comparePrice = formatMoney(cartItem.price, settings.moneyFormat);
        savingPrice = formatMoney((cartItem.price - cartItem.final_price), settings.moneyFormat);
        totalSavings = totalSavings + (cartItem.price - cartItem.final_price);
      }

      item = {
        key: cartItem.key,
        line: index + 1, //Shopify uses a 1+ index in the API
        url: cartItem.url,
        img: prodImg,
        name: cartItem.product_title.toLowerCase(),
        variation: cartItem.variant_title,
        properties: cartItem.properties,
        rechargeProperties: rechargeProperties,
        itemAdd: cartItem.quantity + 1,
        itemMinus: cartItem.quantity - 1,
        itemQty: cartItem.quantity,
        isFinalSale: isFinalSale,
        price: formatMoney(cartItem.final_price, settings.moneyFormat),
        comparePrice: comparePrice,
        savingPrice: savingPrice,
        vendor: cartItem.vendor,
        linePrice: formatMoney(cartItem.line_price, settings.moneyFormat),
        originalLinePrice: formatMoney(cartItem.original_line_price, settings.moneyFormat),
        discounts: cartItem.discounts,
        discountsApplied: cartItem.line_price === cartItem.original_line_price ? false : true
      };

      items.push(item)
   })

   if (recommendedProduct){
     if (recommendedProduct.featured_image != null){
       recommendedProduct.image = {}
       recommendedProduct.image.src = recommendedProduct.featured_image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
       recommendedProduct.image.dataSrc = recommendedProduct.featured_image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
     }
     if (recommendedProduct.price){
       recommendedProduct.formattedPrice = formatMoney(recommendedProduct.price, settings.moneyFormat);
     }
   }

   if (donation){
     if (donation.featured_image != null){
       donation.image = {}
       donation.image.src = donation.featured_image.replace(/(\.[^.]*)$/, "_200x$1").replace('http:', '');
       donation.image.dataSrc = donation.featured_image.replace(/(\.[^.]*)$/, "_900x$1").replace('http:', '');
     }

     if (donation.price){
       donation.formattedPrice = formatMoney(donation.price, settings.moneyFormat);
     }
   }

   var donationInCart = cart.items.find(item => item.product_id === donation.id);

   /*if (document.body.classList.contains('ab-shipping-a')) {
      window.freeShippingSettings = {
        shippingThreshold: 5500,
        progressBarEnabled: true
      }
    } else {
      window.freeShippingSettings = {
        shippingThreshold: 7500,
        progressBarEnabled: true
      }
    }*/

   const { shippingThreshold, progressBarEnabled } = freeShippingSettings;

   let sT = getShippingProgress(cart, shippingThreshold);
   let shippingValue = String(sT).replace("%", "");
   let freeShipping = null;

   if(totalSavings > 0) {
    if(cart.total_discount) {
      setTotalSavings = formatMoney(cart.total_discount, settings.moneyFormat);
    } else {
      setTotalSavings = formatMoney(totalSavings, settings.moneyFormat);

    }
   } else {
      setTotalSavings = null;
   }

   if(shippingValue == "100") {
      freeShipping = 1;
   }

   let cartDiscountCode = null;
   if(cart.cart_level_discount_applications.length > 0) {
    cartDiscountCode = cart.cart_level_discount_applications[0].title;
   } else {
    cartDiscountCode = null;
   }

   console.log(cart);

   let orgTotal = null;
   if(cart.original_total_price != cart.total_price) {
    orgTotal = formatMoney(cart.original_total_price, settings.moneyFormat);
   } 

   data = {
     emptyCart: cart.item_count === 0,
     cartCount: cart.item_count,
     items: items,
     note: cart.note,
     totalPrice: formatMoney(cart.total_price, settings.moneyFormat),
     totalOriginalPrice: orgTotal,
     totalCartDiscount: cart.total_discount === 0 ? 0 : 0,
     totalCartDiscountApplied: cart.total_discount === 0 ? false : true,
     totalSavings: setTotalSavings,
     recommendation: recommendedProduct,
     donationInCart: donationInCart,
     donation: donation,
     earStackDiscount: totalStackCount > 1,
     cartDiscountLevel: cartDiscountCode,

     // actually calculate these variables based on the cart totals and progress. 
     // then style and format the shipping progress bar - using Guava as an example
     progressBarEnabled: progressBarEnabled,
     hasFreeShipping: hasFreeShipping(cart, shippingThreshold), // or false
     progressToFreeShipping: getShippingProgress(cart, shippingThreshold), // calculated off cart total price / shippingThrehold amount
     shippingThreshold: shippingThreshold, // not have this be hardcoded
     shippingValue: shippingValue,
     freeShipping: freeShipping,
     shippingMessage: getShippingMessage(cart, shippingThreshold)
   }

   console.log('DATA --');
   console.log(data);


   let shipThreshold;

  /*if (document.body.classList.contains('ab-shipping-a')) {
    shipThreshold = 5500;
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const cartTotal = cart.total_price;

        if (cartTotal >= shipThreshold) {
          const url = `${window?.Shopify?.routes?.root}discount/FREESHIPPING`;
          fetch(url);
          console.log('Discount applied:', url);
        } else {
          console.log('Cart Total:', cartTotal);
        }
      });
  }*/

   $cartContainer.append(template(data));
  }

  /*******************************************/
  const rewardSettings = window.theme?.rewardSettings?.rewards?.slice(0, window.theme.rewardSettings.count) || [];

  function getRewardLabel(reward) {
    switch (reward.type) {
      case 'free_shipping':
        return 'Free Shipping';
      case 'discount':
        return `${reward.discount}% OFF`;
      case 'free_product':
        return 'a Mystery Gift';
      default:
        return 'a Reward';
    }
  }

  function calculateProgress(total) {
    if (!rewardSettings.length) return 0;

    const thresholds = rewardSettings.map(r => parseFloat(r.threshold));
    const max = Math.max(...thresholds);

    for (let i = 0; i < thresholds.length; i++) {
      const start = i === 0 ? 0 : thresholds[i - 1];
      const end = thresholds[i];
      const percentStart = i === 0 ? 0 : (i) * (100 / rewardSettings.length);
      const percentEnd = (i + 1) * (100 / rewardSettings.length);

      if (total < end) {
        return percentStart + ((total - start) / (end - start)) * (percentEnd - percentStart);
      }
    }

    return 100;
  }

  /*function updateProgressUI(cart) {
    console.log('CART --');
    console.log(cart);
    let adjustedTotalPrice = cart.total_price;

    if(cart.original_total_price) {
      adjustedTotalPrice = cart.original_total_price;
    }
    const navidiumItem = cart.items.find(item => item.handle && item.handle.includes('navidium'));
    if (navidiumItem) {
      adjustedTotalPrice -= navidiumItem.final_price;
    }

    const total = Math.round(adjustedTotalPrice) / 100;
    const fill = document.getElementById('rewards-progress-fill');
    const messageEl = document.querySelector('.rewards-message');
    const messagePDP = document.querySelector('.product-message');
    const messagePDPM = document.getElementById('product-reward-message');
    const markers = document.querySelectorAll('.reward-marker');

    const percent = calculateProgress(total);

    if (fill) {
      fill.style.transition = 'width 0.4s ease';
      requestAnimationFrame(() => {
        fill.style.width = percent + '%';
      });
    }

    let nextReward = null;
    let lastAchieved = null;

    let hasCode = false;

    if(cart.discount_codes) {
      hasCode = cart.discount_codes.some(dc => dc.code === "15DISCOUNT" && dc.applicable === true);
    } else {
      hasCode = false;
    }

    function refreshCartCode() {
      fetch('/cart.js')
      .then(res => res.json())
      .then(updatedCart => {
        buildCart(updatedCart);
        updateProgressUI(updatedCart);

        setTimeout(function() {
          buildCart(updatedCart);
          updateProgressUI(updatedCart);
        }, 200);
      })
      .catch(console.error);
    }

    if((percent > 95) && hasCode == false) {
      const url = `${window?.Shopify?.routes?.root}discount/15DISCOUNT`;
      fetch(url);
      refreshCartCode();
    }

    for (const reward of rewardSettings) {
      const threshold = parseFloat(reward.threshold);
      if (total >= threshold) {
        lastAchieved = reward;
      } else {
        nextReward = reward;
        break;
      }
    }

    if (nextReward && messageEl) {
      const amountLeft = (parseFloat(nextReward.threshold) - total).toFixed(2);
      messageEl.innerHTML = `Add <span class="amount">$${amountLeft}</span> to <strong>get <span class="rewartd">${getRewardLabel(nextReward)}</span></strong>`;
      if(messagePDP && cart.item_count > 0) {
        messagePDPM.style.display = 'flex';
        messagePDP.innerHTML = `Add <span class="amount">$${amountLeft}</span> to <strong>get <span class="rewartd">${getRewardLabel(nextReward)}</span></strong>`;
      }

      if(messagePDP && cart.item_count <= 0) {
        messagePDPM.style.display = 'none';
      }
    } else if (lastAchieved && messageEl) {
      messageEl.innerHTML = `<strong>You unlocked ${getRewardLabel(lastAchieved)}!</strong>`;
      if(messagePDP && cart.item_count > 0) {
        messagePDPM.style.display = 'flex';
        messagePDP.innerHTML = `<strong>You unlocked ${getRewardLabel(lastAchieved)}!</strong>`;
      }

      if(messagePDP && cart.item_count <= 0) {
        messagePDPM.style.display = 'none';
      }
    }

    markers.forEach(marker => {
      const threshold = parseFloat(marker.dataset.goal);
      if (!isNaN(threshold) && total >= threshold) {
        marker.classList.add('reward-achieved');
      } else {
        marker.classList.remove('reward-achieved');
      }
    });

    // Lógica para agregar o quitar Free Gift
    const giftReward = rewardSettings.find(r => r.type === 'free_product' && r.productId);

    if (giftReward) {
      const giftInCart = cart.items.find(item => {
        if (item.variant_id !== giftReward.productId) return false;
        const props = item.properties || {};
        return Object.keys(props).some(key => key.toLowerCase() === 'free gift');
      });

      const achievedGift = total >= parseFloat(giftReward.threshold);

      // Refrescar carrito tras cambios
      function refreshCart() {
        fetch('/cart.js')
          .then(res => res.json())
          .then(updatedCart => {
            buildCart(updatedCart);
            updateProgressUI(updatedCart);

            //setTimeout(function() {
              //buildCart(updatedCart);
              //updateProgressUI(updatedCart);
            //}, 200);
          })
          .catch(console.error);
      }

      // Agregar regalo si alcanzado y aún no está en el carrito
      if (achievedGift && !giftInCart) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            items: [
              {
                id: giftReward.productId,
                quantity: 1,
                properties: {'Free Gift': '1 per purchase'}
              }
            ]
          })
        })
        .then(response => {
          if (response.ok) {
            refreshCart();
          } else {
            console.error('Error adding gift to cart');
          }
        })
        .catch(console.error);
      }

      // Eliminar regalo si ya no se cumple el goal
      if (!achievedGift && giftInCart) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: {'Content-Type': 'application/json'},
          body: JSON.stringify({
            id: giftInCart.key,
            quantity: 0
          })
        })
        .then(response => {
          if (response.ok) {
            refreshCart();
          } else {
            console.error('Error removing gift from cart');
          }
        })
        .catch(console.error);
      }
    }
  }*/


  function updateProgressUI(cart) {
    console.log('CART --');
    console.log(cart);

    let adjustedTotalPrice = cart.total_price;

    // Restar el valor del Free Gift si está con precio mayor a cero
    const giftReward = rewardSettings.find(r => r.type === 'free_product' && r.productId);
    let giftInCart = null;

    if (giftReward) {
      giftInCart = cart.items.find(item =>
        item.variant_id === giftReward.productId &&
        item.properties &&
        Object.keys(item.properties).some(key => key.toLowerCase() === 'free gift')
      );

      if (giftInCart && giftInCart.line_price > 0) {
        adjustedTotalPrice -= giftInCart.line_price;
      }
    }

    const total = Math.round(adjustedTotalPrice) / 100;
    const fill = document.getElementById('rewards-progress-fill');
    const messageEl = document.querySelector('.rewards-message');
    const messagePDP = document.querySelector('.product-message');
    const messagePDPM = document.getElementById('product-reward-message');
    const markers = document.querySelectorAll('.reward-marker');

    const percent = calculateProgress(total);

    if (fill) {
      fill.style.transition = 'width 0.4s ease';
      requestAnimationFrame(() => {
        fill.style.width = percent + '%';
      });
    }

    let nextReward = null;
    let lastAchieved = null;

    let hasCode = false;

    if (cart.discount_codes) {
      hasCode = cart.discount_codes.some(dc => dc.code === "15DISCOUNT" && dc.applicable === true);
    }

    function refreshCartCode() {
      fetch('/cart.js')
        .then(res => res.json())
        .then(updatedCart => {
          buildCart(updatedCart);
          updateProgressUI(updatedCart);
        })
        .catch(console.error);
    }

    if (percent > 95 && !hasCode) {
      const url = `${window?.Shopify?.routes?.root}discount/15DISCOUNT`;
      fetch(url);
      refreshCartCode();
    }

    for (const reward of rewardSettings) {
      const threshold = parseFloat(reward.threshold);
      if (total >= threshold) {
        lastAchieved = reward;
      } else {
        nextReward = reward;
        break;
      }
    }

    if (nextReward && messageEl) {
      const amountLeft = (parseFloat(nextReward.threshold) - total).toFixed(2);
      messageEl.innerHTML = `Add <span class="amount">$${amountLeft}</span> to <strong>get <span class="rewartd">${getRewardLabel(nextReward)}</span></strong>`;
      if (messagePDP && cart.item_count > 0) {
        messagePDPM.style.display = 'flex';
        messagePDP.innerHTML = `Add <span class="amount">$${amountLeft}</span> to <strong>get <span class="rewartd">${getRewardLabel(nextReward)}</span></strong>`;
      }
      if (messagePDP && cart.item_count <= 0) {
        messagePDPM.style.display = 'none';
      }
    } else if (lastAchieved && messageEl) {
      messageEl.innerHTML = `<strong>You unlocked ${getRewardLabel(lastAchieved)}!</strong>`;
      if (messagePDP && cart.item_count > 0) {
        messagePDPM.style.display = 'flex';
        messagePDP.innerHTML = `<strong>You unlocked ${getRewardLabel(lastAchieved)}!</strong>`;
      }
      if (messagePDP && cart.item_count <= 0) {
        messagePDPM.style.display = 'none';
      }
    }

    markers.forEach(marker => {
      const threshold = parseFloat(marker.dataset.goal);
      if (!isNaN(threshold) && total >= threshold) {
        marker.classList.add('reward-achieved');
      } else {
        marker.classList.remove('reward-achieved');
      }
    });

    // FREE GIFT - Agregar o quitar según reglas
    if (giftReward) {
      const achievedGift = total >= parseFloat(giftReward.threshold);

      function refreshCart() {
        fetch('/cart.js')
          .then(res => res.json())
          .then(updatedCart => {
            buildCart(updatedCart);
            updateProgressUI(updatedCart);
          })
          .catch(console.error);
      }

      // Si se alcanzó el objetivo y el regalo no está presente, lo agregamos
      if (achievedGift && !giftInCart) {
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [
              {
                id: giftReward.productId,
                quantity: 1,
                properties: { 'Free Gift': '1 per purchase' }
              }
            ]
          })
        })
          .then(res => {
            if (res.ok) refreshCart();
            else console.error('Error adding free gift');
          })
          .catch(console.error);
      }

      // Si se alcanzó el objetivo pero el regalo tiene precio (!= 0), se elimina
      if (achievedGift && giftInCart && giftInCart.line_price > 0) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftInCart.key,
            quantity: 0
          })
        })
          .then(res => {
            if (res.ok) refreshCart();
            else console.error('Error removing incorrect gift price');
          })
          .catch(console.error);
      }

      // Si ya no se cumple el objetivo y el regalo existe, eliminarlo
      if (!achievedGift && giftInCart) {
        fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            id: giftInCart.key,
            quantity: 0
          })
        })
          .then(res => {
            if (res.ok) refreshCart();
            else console.error('Error removing gift');
          })
          .catch(console.error);
      }
    }
  }


  function fetchCartAndUpdate() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(cart => {
        updateProgressUI(cart);
      })
      .catch(console.error);
  }

  function initCartListeners() {
    const selectors = [
      '.spf-product__form-btn-addtocart',
      '#Product-AddToCart',
      '.js-quickshop-btn',
      '.js-adjust-qty',
      '.js-remove-item',
      '.js-cart',
      '#QuickShop-AddToCart'
    ];

    document.body.addEventListener('click', function (event) {
      const target = event.target.closest(selectors.join(', '));
      if (target && document.body.classList.contains('ab-shipping-threshold')) {
        setTimeout(reRenderCart, 400);
        setTimeout(fetchCartAndUpdate, 1000);
      }
    });

    // Llamada inicial al cargar
    //fetchCartAndUpdate();
  }

  function getPDPInfo() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(updatedCart => {
        updateProgressUI(updatedCart);
      })
      .catch(console.error);
  }

  function reRenderCart() {
    fetch('/cart.js')
      .then(res => res.json())
      .then(updatedCart => {
        buildCart(updatedCart);
      })
      .catch(console.error);
  }

  document.addEventListener('DOMContentLoaded', function () {
    const allSelectors = [
      '.spf-product__form-btn-addtocart',
      '#Product-AddToCart',
      '.js-quickshop-btn',
      '.js-adjust-qty',
      '.js-remove-item',
      '#QuickShop-AddToCart'
    ];

    // Para los selectores generales (excepto .js-cart)
    document.body.addEventListener('click', function (event) {
      const target = event.target.closest(allSelectors.join(', '));
      if (target && document.body.classList.contains('ab-shipping-threshold')) {
        setTimeout(reRenderCart, 400);
        setTimeout(fetchCartAndUpdate, 1000);
      }
    });

    // Para .js-cart específicamente
    document.body.addEventListener('click', function (event) {
      const target = event.target.closest('.js-cart');
      if (target && document.body.classList.contains('ab-shipping-threshold')) {
        setTimeout(fetchCartAndUpdate, 1000);
      }
    });

    /*if(document.body.classList.contains('ab-shipping-threshold')) {
      setTimeout(function() {
        getPDPInfo();
      }, 400);
    }*/

    window.addEventListener('load', function () {
      if(document.body.classList.contains('ab-shipping-threshold')) {
        getPDPInfo();
      }
    });
  });

  return {
    init: init,
    onCartUpdate: onCartUpdate
  }
})();
// +++++++++++++++++++++
// Accordion + FAQ
// +++++++++++++++++++++
var accordion = (function(){

  var settings = {
    title: ".js-accordion-title",
    content: ".js-accordion-content",
    accordionContainer: ".js-accordion",
    activeClass: "active",
    activeClass: "active",
    faqSidebarLink: ".js-faq-link",
    faqMainContent: ".js-faq-main"
  }

  var init = function(){
    if ($(settings.title).length === 0) return;

    initializeEventListeners();

    if (screen.availWidth > 768) {
     $(settings.faqSidebarLink).eq(0).click();
   }
  }

  var initializeEventListeners = function(){
    $(settings.title).on('click', togglePanel);
    $(settings.faqSidebarLink).on('click', toggleMainContent);
  }

  var toggleMainContent = function(e){
   e.preventDefault();

   var $this = $(this);
   var question = $this.data('question');
   var $mainContent = $(settings.faqMainContent + '[data-question="' + question+ '"]');

   if (screen.availWidth > 768) {
     $this.addClass('active');
     $mainContent.show();
   } else {
     $this.toggleClass('active');
     $mainContent.slideToggle(400);
   }

   $(settings.faqSidebarLink).not($this).removeClass('active');
   $(settings.faqMainContent).not($mainContent).hide();
 }

  var togglePanel = function() {
    var $container = $(this).parents( settings.accordionContainer );
    var $currentTitle = $(this);
    var $currentContent = $(this).next( settings.content );

    if ($currentTitle.attr( 'aria-expanded' ) == 'false'){

      var $activeTitle = $container.find( '[aria-expanded=true]' );
      var $activeContent = $container.find( '[aria-hidden=false]' );

      // closes any active titles
      $activeTitle.attr( 'aria-expanded' , false ).removeClass( settings.activeClass );
      // closes any active content
      $activeContent.slideUp(400).attr( 'aria-hidden' , 'true');

      // opens new content
      $currentTitle.attr( 'aria-expanded' , true ).addClass( 'active' );
      $currentContent.slideDown(400).attr( 'aria-hidden' , 'false');

    } else {
      // close the clicked content
      $currentTitle.attr( 'aria-expanded' , false ).removeClass( 'active' );
      $currentContent.slideUp(400).attr( 'aria-hidden' , 'true');
    }
    // No Boing Boing
    return false;
  };

  return {
    init: init
  }
})();

// +++++++++++++++++++++
// Product
// +++++++++++++++++++++
var productPage = (function(){

  var settings = {
    productImages: '[data-slider="product-images"]',
    qtyAdjust: ".qtyadjust",
    container: ".product-panel",
    productSelect: 'select[name="id"]',
    productSection: ".product-section",
    variantSwatch: ".js-variant-swatch",
    productPrice: ".js-product-price",
    productForm: ".js-product-form",
    productJson: '[data-id="Product-JSON"]',
    moneyFormat: "${{ amount }}",
    addToCart: "#Product-AddToCart",
    addToCartBar: '#Product-AddToCart-Bar',
    // addToCartSoldOut: "#Product-ATC-SoldOut",
    specToggle: '.js-spec-toggle',
    specList: '.js-spec-list'
  }

  var product = {};

  var init = function(){
    if (!$(settings.productSection).length) return;

    initializeEventListeners();

    if ($(settings.productJson).length) {
      product = JSON.parse($(settings.productJson).text());
    }
  }

  var updateVariant = function(e){
    var value = $(this).val();
    let label = $(this).find('option:selected').data('label');

    if (product) {
      var variant = product.variants.find(function(variant){
        return variant.id === parseInt(value);
      })

      if (variant) {
        updatePrice(variant);
        updateAvailability(variant, label);
        updateMobileImageSlider(variant);
        updateATCVariant(variant)

        // anything else we might want to update: default images, image in slider, product title

        // Update ATC bar variant
        const $atcBarVariants = $('#AddToCartBar').find('.js-hidden-select option');
        $atcBarVariants.removeAttr('selected');
        $atcBarVariants.filter('[data-title="' + variant.title + '"]').attr('selected', '');
      }
    }
  }

  var updateATCVariant = function(variant){
    $(settings.addToCart).data('variantid', variant.id);
  }

  var updateMobileImageSlider = variant => {
    const $imageSlider = $(settings.productImages + ".slick-initialized");

    const slideCount = $imageSlider.find('.slick-slide').length;
    if ( slideCount <= 1 ) return;

    const $activeImage = $imageSlider.find('img[data-variant="' + variant.id + '"]');
    const $activeSlide = $activeImage.parent().not('.slick-cloned');

    $imageSlider.slick('slickGoTo', $activeSlide.data('slickIndex'));
  }

  var updateAvailability = function(variant, label){
    const $addToCartButtons = $(settings.addToCart + ', ' + settings.addToCartBar);

    if (variant.available) {
      $addToCartButtons.text('add to cart').attr('disabled', false);
      $addToCartButtons.attr('data-available', true)
      $addToCartButtons.removeClass('atc-coming-soon')
      $addToCartButtons.removeClass('btn-secondary')
    } else {
      let comingSoon = $addToCartButtons.data('coming-soon');
      $addToCartButtons.attr('data-available', false)

      if(comingSoon === 1) {
        $addToCartButtons.text('coming soon, join the waitlist');
        $addToCartButtons.addClass('atc-coming-soon')
        $addToCartButtons.addClass('btn-secondary')
      } else {
        $addToCartButtons.text('join the waitlist');
        $addToCartButtons.addClass('atc-coming-soon')
        $addToCartButtons.addClass('btn-secondary')
      }
    }
  }

  var updatePrice = function(variant){
    var formattedPrice = formatMoney(variant.price, settings.moneyFormat);
    $(settings.productPrice).text(formattedPrice);
  }

  // AA fixed for multiple inputs.
  var updateQuantity = (function(e){
    e.preventDefault();

    var $qtyInput = $(this).siblings('.js-quantityInput')

    var qty = $qtyInput.val();

    if ($(this).hasClass('qtyplus')){
      qty++;
    } else {
      if(qty > 1) {
        qty--;
      }
    }

    qty = (isNaN(qty)) ? 1 : qty ;
    $qtyInput.val(qty).change();

    // Update ATC bar quantity
    $('.js-quantityInput-bar').val(qty).change();
  });

  var handleSpecToggle = function(e){
    e.preventDefault();

    $(this).toggleClass('active');
    $(settings.specList).slideToggle(300);
  }

  var addToCartSoldOut = function(e) {
    var $this = $(this);
    var variantid = $this.data('variantid');
    var available = $this.attr('data-available');

    // if variant is not available, show popover.
    if (available === "false") {

      if (typeof SIPopover !== "undefined"){
        SIPopover.show({ variantId: variantid });
      } else {
        let popoverInterval = setInterval(function(){
          if (typeof SIPopover !== "undefined"){
            SIPopover.show({ variantId: variantid });
            clearInterval(popoverInterval);
          }
        }, 150)
      }
    }
  }

  var initializeEventListeners = function(){
    $(settings.addToCart).on('click', addToCartSoldOut);
    $(settings.addToCartBar).on('click', addToCartSoldOut);
    // $(settings.addToCartSoldOut).on('click', addToCartSoldOut);
    $(settings.qtyAdjust).on("click", updateQuantity);
    $(settings.productSelect).on('change', updateVariant);
    // $(settings.variantSwatch).on('change', updateVariant);
    $(settings.specToggle).on('click', handleSpecToggle);
  }

  return {
    init: init
  }

})();

var customSelect = function(node){
  var settings = {
    customSelect: ".js-custom-select",
    selectTrigger: ".js-custom-trigger",
    selectOption: ".js-custom-option",
    hiddenSelect: ".js-hidden-select",
    swatch: ".js-custom-swatch",
    section: "#shopify-section-product-panel",
    imageSlider: '[data-slider="product-images"]',
    controllerSlider: '[data-slider="product-images-controller"]',
    productImages: "[data-product-image]"
  }

  let cache = {}

  let wrapper = document, product = {};

  ;(function(){
    if (node) {
      wrapper = node;
    }

    initializeCache()

    product = getProduct();

    initializeEventListeners()
    relateOptionsToVariants()

    $(document).watchFor('.slick-initialized', ($el) => {
      $el.each((index, container) => {
        let $defaultVariant = $(settings.section).find(settings.hiddenSelect).find(":selected").val();
        if (!$defaultVariant) {
          // for products with no variants
          $defaultVariant = product.variants[0].id;
        }

        let $firstImgID = $(settings.section).find(settings.productImages).first().data('variant')
        filterProductImages($defaultVariant);
      })
    })
  })();

  function initializeCache(){
    const $wrapper = $(wrapper);

    cache = {
      customSelect: $wrapper.find(".js-custom-select"),
      selectTrigger: $wrapper.find(".js-custom-trigger"),
      selectOption: $wrapper.find(".js-custom-option"),
      hiddenSelect: $wrapper.find(".js-hidden-select"),
      swatch: $wrapper.find(".js-custom-swatch"),
      section: $wrapper.find("#shopify-section-product-panel"),
      imageSlider: $wrapper.find('[data-slider="product-images"]'),
      controllerSlider: $wrapper.find('[data-slider="product-images-controller"]'),
      productImages: $wrapper.find("[data-product-image]")
    }
  }

  function getProduct() {
    let productJSON = $(wrapper).find('[data-id="Product-JSON"]').text()
    return JSON.parse(productJSON)
  }

  function relateOptionsToVariants() {
    const $options = cache.customSelect.find('[data-component="product-option"]') /* this is the indiv input component */

    const selectedOptions = getSelectedOptions($options)
    const optionTypes = selectedOptions.map((option) => {
      return $options.filter(`[value="${option}"], [data-value="${option}"]`).attr('name')
    })
    const allCombinations = generateCombinations($options, optionTypes)
    disableUnavailableOptions($options, allCombinations)

  }

  function getSelectedOptions($options) {
    const $selectedOptions = $options.filter('input:checked, .select-option.active')
    const $selOptions = $options.filter('.select-option.active')

    return $selectedOptions.map((index, element) => {
      let $element = $(element);
      if ($element.is('input')) return $(element).val()
      if ($element.is('.select-option')) return $element.data('value')
    }).get()
  }

  /**
   * Generates all possible combinations of options.
   * @param {Array} optionTypes - The option types.
   * @returns {Array} - All combinations of options.
   */
  function generateCombinations($options, optionTypes) {
    return optionTypes.reduce((accumulator, currentType) => {
      const $currentOptions = $options.filter(`[name="${currentType}"]`) // removed :not(:checked)
      const otherOptionTypes = optionTypes.filter((item) => item !== currentType)
      const $otherSelectedOptions = $options.filter((index, option) => {
        if ($(option).is('input')) return otherOptionTypes.includes($(option).attr('name')) && $(option).is(':checked')
        if ($(option).is('.select-option')) return otherOptionTypes.includes($(option).attr('name')) && $(option).is('.active')
      })
      const selectedOptions = $otherSelectedOptions.map((index, option) => {
        let $element = $(option);
        if ($element.is('input')) return $element.val()
        if ($element.is('.select-option')) return $element.data('value')
      }).get()
      const combinations = $currentOptions.get().map((option) => {
        let dynamicOption;
        if ($(option).is('input')) {
          dynamicOption = $(option).val()
        } else if ($(option).is('.select-option')) {
          dynamicOption = $(option).data('value')
        }
        return {
          dynamicOption: dynamicOption,
          ...selectedOptions,
        }
      })

      return [...accumulator, ...combinations]
    }, [])
  }

  function getVariant(selectedOptions) {
    return product.variants.find(function (variant) {
      if (variant.options.sort().join(',') === selectedOptions.sort().join(',')) {
        return variant
      }
    })
  }

  /**
   * Disables options that are not available in any combination.
   * @param {Array} combinations - The combinations of options.
   */
  function disableUnavailableOptions($options, combinations) {
    $options.parent().removeClass('diagonal-strikethrough')

    combinations.forEach((combination) => {
      const variant = getVariant(Object.values(combination))

      if (!variant || !variant.available) {

        $options.filter(`[value="${combination.dynamicOption}"]`).parent().addClass('diagonal-strikethrough')
        $options.filter(`[data-value="${combination.dynamicOption}"]`).addClass('select-option-unavailable')

      }
    })
  }

  function initializeEventListeners(){
    cache.selectTrigger.off().on('click', toggleSelect);
    cache.selectOption.off().on('click', setActiveOption);

    cache.swatch.off().on('click', setActiveOptionFromSwatch);
  }

  function toggleSelect (e){
    relateOptionsToVariants();
    cache.customSelect.toggleClass('open');
  }

  function generateSrcSet(imageSrc) {
    const WIDTHS = [180, 360, 470, 600, 770, 970, 1060, 1280, 1512, 1728, 2048];
    const regex = (/\.(gif|jpe?g|tiff?|png|webp|bmp)/)
    const srcset = [];
    let matches = imageSrc.match(regex)

    if (matches) {
      for (let width of WIDTHS) {
        let matchPrefix = "_" + width + "x" + (matches[0]);
        let newSrc = imageSrc.replace(regex, matchPrefix);
        srcset.push(`${newSrc} ${width}w`);
      }
    }

    return srcset.join(',');
  }
  
  function getCurrentVariant(selectedVariantId) {
    if (product && product.variants){
      let variantData = product.variants;
      let parsedId = parseInt(selectedVariantId)      
      let currentVariant = variantData.find((variant) => {
        return variant.id === parsedId
      });

      return currentVariant;
    } else {
      return {};
    }
  } 

  function filterBySku(element, sku){
    let imgSKUs = $(element).find("img").data("variant-sku");
    let hasSKU = imgSKUs && imgSKUs.includes(sku)
    return hasSKU || $(element).find(`[data-variant-sku="all"]`).length
  }

  var alignIndexes = function(index, element) {
    $(element).attr('data-slick-index', index);
  }

  function resizeControllerSlides() {
    let { section, controllerSlider } = settings;
    let $controllerSlider = $(section).find(controllerSlider);
    $controllerSlider.find(".slick-track").css("width", "100%");
    $controllerSlider.find('.slick-slide').each((index, element) => {
      let parentWidth = $(element).parent().parent().width();
      let totalSlides = $controllerSlider.find('.slick-slide').length;
      let slideWidth = (parentWidth/totalSlides) + "px";
      $(element).css('width', slideWidth);
    })
  }

  function filterProductImages(variantValue) {
    let { section, imageSlider, productImages, controllerSlider } = settings;
    let $imageSlider = $(section).find(imageSlider);
    let filterImages = $imageSlider.data('filter-images');
    let variant = getCurrentVariant(variantValue);

    if (!variant) return;

    let { sku } = variant;

    $imageSlider.slick('slickUnfilter')
    let $controllerSlider = $(section).find(controllerSlider);
    $controllerSlider.slick('slickUnfilter')

    let $productImages = $(section).find(productImages);
    let sliderActive = $imageSlider.hasClass('slick-initialized');
    let visibleImages = [];
    if (filterImages) {
      visibleImages = $productImages.filter(function() {
        let $sku = $(this).data("variant-sku");
        if (!$sku) return false;
        if ($sku.includes(sku)) return true;
        if ($sku.includes("all")) return true;
      });
    }
    if (sliderActive) {
      if (filterImages && visibleImages && visibleImages.length) {
       // $imageSlider.slick('slickUnfilter')
        $productImages = $imageSlider.find(productImages);
        $imageSlider.slick('slickFilter', (index, element) => filterBySku(element, sku))
        $controllerSlider.slick('slickFilter', (index, element) => filterBySku(element, sku))

        $imageSlider.find('.slick-slide').each((index, element) => alignIndexes(index, element));
        $controllerSlider.find('.slick-slide').each((index, element) => alignIndexes(index, element));
        
        resizeControllerSlides();

        // Go to first image
        $imageSlider.slick('slickGoTo', 0);
        $controllerSlider.slick('slickGoTo', 0);
        $productImages.show();

      } else if (!filterImages &&  $productImages.length) {
        $imageSlider.slick('slickGoTo', 0);
        $controllerSlider.slick('slickGoTo', 0);
        $productImages.show();
        resizeControllerSlides();
      }
    } else {
      // Need to make two options: 1 for slick, 1 for
      let visibleImages = $productImages.filter(function() {
        return $(this).data("variant-sku").includes(sku);
      });
      let allImages = $($productImages).filter(`[data-variant-sku="all"]`)
      visibleImages = visibleImages.add(allImages);

      if (visibleImages.length > 0) {
        visibleImages.show()

        if (visibleImages.length === 1) {
          visibleImages.addClass('row-span-2 col-span-2')
        } else {
          visibleImages.removeClass('row-span-2 col-span-2')
        }

        $($productImages).not(visibleImages).hide()
      } else {
        $($productImages).show()
      }
    }
  }

  function updateText(variantValue) {
    let variant = getCurrentVariant(variantValue);

    $(".option-name-value").each((index, el) => {
      let $el = $(el)
      let optionString = 'option' + (index+1);
      $el.text(variant[optionString]);
    })

    let descSelector = ".js-variant-desc--" + variant.id;
    let titleSelector = ".js-variant-title--" + variant.id;
    $(".js-variant-desc.current").removeClass("current").addClass("hidden")
    $(descSelector).removeClass("hidden").addClass("current");

    $(".js-variant-title.current").removeClass("current").addClass("hidden")
    $(titleSelector).removeClass("hidden").addClass("current");
  }

  function setActiveOption(e){
    var $this = $(this);
    var $form = $this.parents('.js-product-form');

    var $otherOptions = cache.selectOption.not($this);
    var $selectContainer = $this.parents(settings.customSelect);
    var id = $selectContainer.data('for');

    $this.addClass("active");
    $otherOptions.removeClass("active");

    var options = $form.find(settings.selectOption + ".active");
    var swatches = $form.find(settings.swatch + ":checked");

    var activeVariantNames = []

    options.each(function(index, opt){
      activeVariantNames.push($(opt).data('value'))
    })

    swatches.each(function(index, swatch){
      activeVariantNames.push(swatch.value)
    })

    var $hiddenSelect = $("#" + id);

    var activeVariantValue;
    $hiddenSelect.find('option').each(function(index, option){

      var title = $(option).data('title');
      var titles = title.split(" / ");
      var matchedNames = activeVariantNames.filter(function(variantName){
        return titles.includes(variantName.toString());
      });
      

      if (matchedNames.length === activeVariantNames.length) {
        activeVariantValue = $(option).val();
      }
    });

    if ( activeVariantValue ) {
      $hiddenSelect.val(activeVariantValue).change();
      filterProductImages(activeVariantValue);
      updateText(activeVariantValue);
      
      // Update pair price message if pair is selected
      updatePairPriceOnVariantChange($form);
    }
    toggleSelect();
  }

  function setActiveOptionFromSwatch(e) {
    relateOptionsToVariants();
    var $this = $(this);
    var $form = $this.parents('.js-has-custom-select');
    var $selectContainer = $this.parents(settings.customSelect);
    var id = $selectContainer.data('for');
    // var value = $this.data('value');
    
    var options = $form.find(settings.selectOption + ".active");
    var swatches = $form.find(settings.swatch + ":checked");
    
    var activeVariantNames = []
    
    options.each(function(index, opt){
      activeVariantNames.push($(opt).data('value'))
    })
    
    swatches.each(function(index, swatch){
      activeVariantNames.push(swatch.value)
    })

    var $hiddenSelect = $("#" + id);

    var activeVariantValue;

    $hiddenSelect.find('option').each(function(index, option) {

      var title = $(option).data('title');
      var titles = title.split(" / ");

      var matchedNames = activeVariantNames.filter(function(variantName) {
        return titles.includes(variantName.toString());
      });

      if ( matchedNames.length === activeVariantNames.length ) {
        activeVariantValue = $(option).val();
      }
    });


    if ( activeVariantValue ) {
      filterProductImages(activeVariantValue);
      $hiddenSelect.val(activeVariantValue).change();

      updateText(activeVariantValue);
      
      // Update pair price message if pair is selected
      updatePairPriceOnVariantChange($form);
    }
  }

  function updatePairPriceOnVariantChange($form) {
    // Check if pair is selected
    var $pairRadio = $form.find('.js-single-pair-radio[value="Pair"]:checked');
    if ($pairRadio.length) {
      // Get the pair radio button data
      var pieces = $pairRadio.closest('.single-pair-option').data('pieces');
      var value = $pairRadio.val();
      
      // Update the pair price message directly
      singlePairSelector.updatePairPriceMessage($pairRadio, pieces, value);
    }
  }
};

// +++++++++++++++++++++
// Single/Pair Selector
// +++++++++++++++++++++
var singlePairSelector = (function(){
  var settings = {
    singlePairRadio: '.js-single-pair-radio',
    singlePairSelect: '.js-single-pair-select',
    quantityInput: '.js-quantityInput',
    quantityInputBar: '.js-quantityInput-bar',
    piecesProperty: '.js-pieces-property'
  }

  var init = function(){
    if (!$(settings.singlePairSelect).length) {
      return;
    }
    
    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    $(document).on('change', settings.singlePairRadio, handleSinglePairChange);
  }

  var handleSinglePairChange = function(e){
    var $radio = $(this);
    var pieces = $radio.closest('.single-pair-option').data('pieces');
    var value = $radio.val();
    
    // Update quantity inputs
    var $quantityInput = $radio.closest('form').find(settings.quantityInput);
    var $quantityInputBar = $(settings.quantityInputBar);
    
    if ($quantityInput.length) {
      $quantityInput.val(pieces);
    }
    if ($quantityInputBar.length) {
      $quantityInputBar.val(pieces);
    }
    
    // Update properties hidden input
    var $piecesProperty = $radio.closest('form').find(settings.piecesProperty);
    if ($piecesProperty.length) {
      $piecesProperty.val(value);
    }
    
    // Update pair price message
    updatePairPriceMessage($radio, pieces, value);
    
    // Add visual feedback
    $radio.closest(settings.singlePairSelect).find('.single-pair-option').removeClass('active');
    $radio.closest('.single-pair-option').addClass('active');
  }

  var updatePairPriceMessage = function($radio, pieces, value) {
    var $form = $radio.closest('form');
    var $hiddenSelect = $form.find('select[name="id"]');
    var selectId = $hiddenSelect.attr('id');
    var productId = selectId ? selectId.replace('product-select-', '') : 'default';
    var $pairMessage = $('#pair-price-message-' + productId);
    
    if (value === 'Pair' && pieces === 2) {
      // Get current variant price
      var $hiddenSelect = $form.find('select[name="id"]');
      var selectedVariantId = $hiddenSelect.val();
      var selectedOption = $hiddenSelect.find('option[value="' + selectedVariantId + '"]');
      var variantPrice = parseFloat(selectedOption.data('price'));
      
      if (variantPrice && !isNaN(variantPrice)) {
        var pairPrice = variantPrice * 2;
        var formattedPrice = formatMoney(pairPrice);
        
        $pairMessage.find('.pair-price-text').text('Pair price: ' + formattedPrice);
        $pairMessage.fadeIn();
      }
    } else {
      $pairMessage.fadeOut();
    }
  }

  var formatMoney = function(cents) {
    // Convert cents to dollars and format
    var dollars = cents / 100;
    return '$' + dollars.toFixed(2);
  }

  return {
    init: init,
    updatePairPriceMessage: updatePairPriceMessage
  }
})();


// AA Animation Module
// Use for adding animations on page scroll / element in view
// Specific fade in for footer
var animations = (function(){
  var classes = {
    willAnimate: '.will-animate',
    isAnimating: 'animate',
  }

  var windowHeight = window.screen.availHeight;
  var mobileOffset = window.screen.availWidth < 500 ? 200 : 0;

  var checkForAnimations = function(e){
    var $animateableElements = $(classes.willAnimate);
    $animateableElements.each(function(index, element){
      var elementY = element.getBoundingClientRect().y;
      if ((elementY < windowHeight - 150) && (elementY >= -10)) {
        // Element is in view!
        if (element.dataset.delay){
          var delay = parseInt(element.dataset.delay);
          setTimeout(function(){
            element.classList.add(classes.isAnimating);
          }, delay);
        } else {
          element.classList.add(classes.isAnimating);
        }
      }
    })
  }

  var init = function(){
    if ($(classes.willAnimate).length === 0 ) {
      return
    }

    var interval = setInterval(checkForAnimations, 300);
  }

  return{
    init: init
  }
})();


// +++++++++++++++++++++
// Account
// +++++++++++++++++++++
var account = (function() {
  var settings = {
    recoverPasswordForm: "#RecoverPasswordForm",
    customerLoginForm: "#CustomerLoginForm",
    recoverPasswordLink: ".js-recover-password",
    container: "#account-page",
    accountAddresses: ".address-country-option",
    newAddressToggle: ".address-new-toggle",
    newAddressForm: "#AddressNewForm",
    editAddressToggle: ".address-edit-toggle",
    accountLoginSubmit: ".account-login"
  }

  var init = function(){
    if ($(settings.container).length === 0) {
      return;
    }

    initializeEventListeners();
    initializeAddressForms();
  }

  var initializeEventListeners = function(){
    $(settings.recoverPasswordLink).on('click', toggleRecoverForm);
    $(settings.newAddressToggle).on('click', toggleNewAddressForm);
    $(settings.editAddressToggle).on('click', toggleEditAddressForm);
    $(settings.accountLoginSubmit).on('on', redirectToAccount);
  }

  var initliazeReChargeLinks = function(e){
    var token = sessionStorage.getItem('rc_token');
    if (token) {
      $(settings.rechargeLinks).each(function(index, link){
        var href = $(link).attr('href');
        href += (href.includes("?") ? "&token=" + token : "?token=" + token);

        $(link).attr('href', href);
      })
    }
  }
  
  var redirectToAccount = function(e) {
    e.preventDefault();
    window.location = "/account";
  }

  var toggleRecoverForm = function(e){
    e.preventDefault();
    $(settings.customerLoginForm).toggleClass('hide');
    $(settings.recoverPasswordForm).toggleClass('hide');
  }

  var toggleEditAddressForm = function(e){
    e.preventDefault();

    var formId = $(this).attr('aria-owns');
    var $form = $("#" + formId);

    $form.toggleClass('hide');

    if ($form.hasClass('hide')) {
      $(this).text('edit');
    } else {
      $(this).text('cancel');
    }
  }

  var toggleNewAddressForm = function(e){
    e.preventDefault();
    $(settings.newAddressForm).toggleClass('hide');

    if ($(settings.newAddressForm).hasClass('hide')) {
      $(this).text('new address');
    } else {
      $(this).text('cancel');
    }
  }


  var initializeAddressForms = function(){
    $(settings.accountAddresses).each(function(index, element){
      var formId = $(this).data('form-id');
      var countrySelector = 'AddressCountry_' + formId;
      var provinceSelector = 'AddressProvince_' + formId;
      var containerSelector = 'AddressProvinceContainer_' + formId;

      // eslint-disable-next-line no-new
      new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
        hideElement: containerSelector
      });
    });
  }

  return {
    init: init
  };
})()


// +++++++++++++++++++++
// "Journey" Section Range
// +++++++++++++++++++++
const journeyRange = {
  settings: {
    section: '.js-section-journey',
    tabList: '.js-follow-range-list',
    range: '.js-follow-range',
    thumb: '.js-thumb',
    swipe: '.js-swipe',
    slickClass: 'slick-initialized'
  },

  init: function() {
    this.find();
  },

  find: function() {
    const $sections = $(this.settings.section);
    if ( !$sections.length ) { return; }

    $sections.each((i) => {
      const $section = $($sections[i]);

      $(window).on('resize', () => this.handleResize($section));
      this.handleResize($section);
    });
  },

  handleResize: function($section) {
    const $list = $section.find(this.settings.tabList);
    const $listItem = $list.find('li');
    const maxWidth = parseInt($listItem.css('max-width'), 10);

    if ( $listItem.length * maxWidth >= $section.width() ) {
      this.initSlider($list);
      this.updateSlides($section, $list, maxWidth);
      this.mobileRange($section, $listItem);
    } else {
      this.killSlider($list);
      this.desktopRange($section, $listItem);
    }
  },

  initSlider: function($list) {
    if ( $list.hasClass(this.settings.slickClass) ) { return; }

    const slickSettings = {
      arrows: false,
      centerMode: true,
      infinite: false,
      slidesToShow: 3,
      swipeToSlide: true,
      variableWidth: true
    };

    $list.slick(slickSettings);
  },

  killSlider: function($list) {
    if ( !$list.hasClass(this.settings.slickClass) ) { return; }

    $list.slick('unslick');
  },

  updateSlides: function($section, $list, maxWidth) {
    if ( !$list.hasClass(this.settings.slickClass) ) { return; }

    const slidesToShow = Math.floor($section.width() / maxWidth);

    if ( $list.slick('slickGetOption', 'slidesToShow') == slidesToShow ) { return; }

    $list.slick('slickSetOption', 'slidesToShow', slidesToShow, true);
  },

  mobileRange: function($section, $listItems) {
    const $range = $section.find(this.settings.range);
    const $thumb = $section.find(this.settings.thumb);

    const cssLeft = parseInt($range.css('left'), 10);
    const cssRight = parseInt($range.css('right'), 10);

    if ( cssLeft == 0 && cssRight == 0 ) { return; }

    $listItems.each(function() {
      $(this).find('a').off('mouseenter');
    })
    $range.css({ left: 0, right: 0 });

    $thumb.removeClass('desktop');
    $thumb.css('left', '');

    $thumb.find(this.settings.swipe).removeClass('hide');
  },

  desktopRange: function($section, $listItems) { // Calculate centers of journey slides
    const $range = $section.find(this.settings.range);
    const $thumb = $section.find(this.settings.thumb);
    const $swipe = $thumb.find(this.settings.swipe);

    $listItems.each(function(i) {
      const $item = $(this);

      var offset = $item.offset();
      var width = $item.outerWidth();
      var center = offset.left + width / 2;

      if ( i === 0 ) {
        const leftPos = center - 8;
        $range.css({ left: leftPos });
      }

      if ( i === $listItems.length - 1 ) {
        const rightPos = $(window).outerWidth() - center;
        $range.css({ right: rightPos });
      }

      $thumb.addClass('desktop');
      $item.find('a').on('mouseenter', function() {
        $thumb.css({ left: `calc((100% / 3) * ${ i })` });
      });

      $swipe.addClass('hide');
    });
  }
};


// +++++++++++++++++++++
// sections/index-categories.liquid
// +++++++++++++++++++++
const indexCategories = {
  init: function() {
    const $list = $('.js-categories');

    if ( !$list.length ) { return; }

    $list.slick({
      infinite: false,
      slidesToShow: 1,
      slidesToScroll: 1,
      swipeToSlide: true,
      prevArrow: $list.siblings('.slick-prev'),
      nextArrow: $list.siblings('.slick-next')
    });
  }
};


// +++++++++++++++++++++
// sections/index-testimonials.liquid
// +++++++++++++++++++++
const indexTestimonials = {
  settings: {
    wrapper: '.js-height-match',
    slide: '.testimonial'
  },

  init: function() {
    $(this.settings.wrapper).on('setPosition', () => this.matchHeight());
  },

  matchHeight: function() {
    const $slides = $(this.settings.wrapper).find(this.settings.slide);

    // Reset height
    $slides.each(function() { $(this).height('auto') });

    const slideHeights = $slides.map(function() {
      return $(this).outerHeight();
    });

    const maxWidth = Math.max(...slideHeights);

    $slides.each(function() {
      $(this).height(maxWidth);
    });
  }
}


// +++++++++++++++++++++
// Footer
// +++++++++++++++++++++
const footer = {
  settings: {
    currencySelector: '.js-currency-selector',
    newsletter: '.js-newsletter'
  },

  init: function() {
    if ( $(this.settings.currencySelector.length) ) {
      currencySelector.init();
    }
    if ( $(this.settings.newsletter.length) ) {
      newsletter.init();
    }
  }
};


// +++++++++++++++++++++
// [Footer] Newsletter
// +++++++++++++++++++++
const newsletter = {
  settings: {
    activeClass: 'active',
    emailInput: 'input[type="email"]',
    newsletter: '.js-newsletter'
  },

  init: function() {
    const { activeClass, emailInput, newsletter } = this.settings;

    const $newsletter = $(newsletter);
    const $emailInput = $newsletter.find(emailInput);

    $emailInput.on('input', function(e) {
      const email = $(this).val();

      if ( email.length ) {
        $newsletter.addClass(activeClass);
      } else {
        $newsletter.removeClass(activeClass);
      }
    });
  }
};

// +++++++++++++++++++++
// [Footer] Currency Selector
// +++++++++++++++++++++
const currencySelector = {
  settings: {
    form: '.js-currency-selector',
    button: '.js-currency-selector-btn',
    list: '.js-currency-selection-list',
    selection: '.js-currency-selection',
    activeClass: 'active',
    currencyCode: '[name="currency_code"]'
  },

  init: function() {
     this.initEventListeners();
  },

  initEventListeners: function() {
    const { button, selection } = this.settings;

    $(button).on('click', () => this.handleButton());
    $(selection).on('click', (e) => this.handleCurrencySelection(e));
  },

  handleButton: function() {
    this.toggleList();
  },

  handleCurrencySelection: function(e){
    e.preventDefault();
    const { form, currencyCode } = this.settings;

    var $target = $(e.target);

    var currencyInput = $(form).find(currencyCode);
    currencyInput.val($target.data('value'));

    $(form).submit();
  },

  toggleList: function() {
    const { list, activeClass } = this.settings;

    $(list).toggleClass(activeClass);
  }
};

var quickShop = (function(){
  var settings = {
    quickShopBtn: ".js-quickshop-btn",
    quickShopContainer: ".js-quick-shop-container",
    quickShopContent: ".js-quick-shop-content",
    quickShopImages: ".js-quickshop-images",
    closeButton: ".js-quickshop-close",
    overlay: ".js-quickshop-overlay",
    productSelect: 'select[name="id"]',
    variantSwatch: ".js-variant-swatch",
    productPrice: ".js-product-price",
    productForm: ".js-product-form",
    productJson: '[data-id="Product-JSON"]',
    moneyFormat: "${{ amount }}",
    addToCart: "#QuickShop-AddToCart",
    wishlistImage: '.ssw-fave-product-avatar',
  }

  var product;

  var init = function(){
    if (!$(settings.quickShopContainer).length) return;

    initEventListeners();
  }

  var initEventListeners = function(){
    $(document).on('click', settings.quickShopBtn, getQuickShopContent);
    $(document).on('click', settings.closeButton + ", " +  settings.overlay, closeQuickShop);

    $(document).on('change', settings.productSelect, updateVariant);
    $(document).watchFor(settings.wishlistImage, ($el) => wishlistImg($el));
  }

  var wishlistImg = function($el) {
    $el.each((index, img) => {
      let $img = $(img);
        let oldUrl = $img.attr("href"); // Get current url
        let newUrl = "";
        if (oldUrl.includes('?variant=')) {
          newUrl= oldUrl + '&view=quickshop';
        } else {
          newUrl= oldUrl + '?view=quickshop';
        }
        $img.on('click', {url: newUrl }, getQuickShopContent);
    })
  }

  var initializeImageSlider = function(){
    var slickConfig = {
      slidesToShow: 1,
      slidesToScroll: 1,
      arrows: true,
      nextArrow: ".js-quickshop-next",
      prevArrow: ".js-quickshop-prev",
      focusOnSelect: true,
      infinite: false,
      vertical: false,
      adaptiveHeight: false,
      dots: true
    }

    $(settings.quickShopImages).slick(slickConfig);
  }

  var getQuickShopContent = function(e){
    e.preventDefault();
    e.stopPropagation();
    var quickShopUrl;
    if(e.data && e.data.url) {
      quickShopUrl = e.data.url;
    } else {
      quickShopUrl = $(this).data('url');
    }
    var params = {
      url: quickShopUrl,
      success: function(response){
        var content = $(response).closest('.js-content');
        var json = $(response).find(settings.productJson);

        $(settings.quickShopContainer).addClass('active');
        $(settings.quickShopContent).html(content);
        addNoScroll();

        if (json.length) {
          product = JSON.parse(json.text());
        }

        initializeImageSlider()
      }
    }

    $.ajax(params);

  }

  var updateVariant = function(e){
    var value = $(this).val();

    
    let label = $(this).find('option:selected').data('label');
    
    if (product) {
      var variant = product.variants.find(function(variant){
        return variant.id === parseInt(value);
      })

      if (variant) {
        updatePrice(variant);
        updateAvailability(variant, label);
        updateImage(variant);
        // anything else we might want to update: default images, image in slider, product title
      }
    }
  }

  var updateAvailability = function(variant, label){
    if (variant.available) {
      $(settings.addToCart).text('add to cart').attr('disabled', false);
    } else {
      $(settings.addToCart).text(label).attr('disabled', true);
    }
  }

  var updatePrice = function(variant){
    var formattedPrice = formatMoney(variant.price, settings.moneyFormat);
    $(settings.productPrice).text(formattedPrice);
  }

  var updateImage = function(variant){
    var $imageSlider = $(settings.quickShopImages + '.slick-initialized');
    var $topImage = $imageSlider.find('img').first();

    if ( !variant.featured_image ) { return; }

    var variantImage = variant.featured_image.src;
    $topImage.attr('srcset', variantImage);
    
    $imageSlider.slick('slickGoTo', 0);
  }

  var closeQuickShop = function(e){
    e.preventDefault();

    product = undefined;

    $(settings.quickShopImages).slick('unslick');
    $(settings.quickShopContainer).removeClass('active');
    $(settings.quickShopContent).empty();
    removeNoScroll();
  }

  return {
    init: init
  }
})()


var collection = (function(){
  var settings = {
    container: ".js-collection",
    productCardImage: ".js-product-card-image",
    productCard: ".js-product-card",
    // swatch: ".js-variant-swatch",
    hiddenSelect: '.js-hidden-select',
    additionalSwatch: ".js-additional-swatch",
    toggleSwatches: ".js-toggle-additional-swatches",
    swatchExpandText: ".js-expand-swatches",
    swatchHideText: ".js-hide-swatches",
    filterContainerParent: ".js-filter-container-parent",
    filterContainer: ".js-filter-container",
    filterToggle: ".js-filter-toggle",
    filterInputs: ".js-filter-input",
    resetFilters: ".js-reset-filters",
    sortOption: ".js-collection-sort",
    collectionGrid: ".js-collection-grid",
    testimonialCards: ".js-testimonial-cards",
    selectedTextCount: ".js-selected-count",
    selectedText: ".js-selected-text",
    descriptionToggle: ".js-description-toggle",
    shortDescription: '.js-short-description',
    fullDescription: '.js-full-description'
  }

  var filters = {
    material: [],
    color: [],
    placement: [],
    category: [],
    backType: []
  }

  var $testimonialCards = $(settings.testimonialCards); // grab all testimonial cards on page load.

  const init = function(){
    if (!$(settings.container).length) return;

    initializeEventListeners();
  }

  const initializeEventListeners = function(){
    // $(settings.filters).on('click', function(){});
    $(document).on('change', settings.hiddenSelect, handleSelectChange);
    $(document).on('click', settings.filterToggle, toggleFilters);
    $(document).on('click', settings.sortOption, handleCollectionSort);
    $(document).on('click', settings.resetFilters, resetFilters);
    $(document).on('change', settings.filterInputs, handleFilterChange);
    $(document).on('click', settings.descriptionToggle, toggleDescription);
    $(document).on('click', settings.toggleSwatches, toggleSwatches);

  }

  var handleSelectChange = function(e){
    // don't go to product page
    e.stopPropagation();

    var $this = $(this);
    let $activeOption = $this.find('option:selected');
    var srcset = $activeOption.data('image');
    var value = $this.val();
    var $card = $this.parents(settings.productCard);
    var $link = $card.find('a');
    var $img = $card.find(settings.productCardImage);

    // Update image srcset
    if (srcset && $img.length) {
      $img.attr('srcset', srcset);
    }

    // Update link URL param
    if (value && $link.length) {
      var href = $link.attr('href');
      if (href.includes("variant=")) {
        href = href.replace(/variant=\d+/, ("variant=" + value));
      } else {
        href += href.includes("?") ? ("&variant=" + value) : ("?variant=" + value);
      }

      $link.attr('href', href);
    }
  }

  var toggleFilters = function(){
    $(settings.filterContainer).toggleClass('active');
    $(settings.filterContainerParent).toggleClass('active');
  }

  var handleFilterChange = function(e){
    var $this = $(this);
    var $accordionContainer = $this.parents('.js-accordion')
    var $selectedText = $accordionContainer.find(settings.selectedText);
    var $selectedTextCount = $accordionContainer.find(settings.selectedTextCount);

    var name = $this.attr('name');
    var value = $this.val();
    if (filters[name].includes(value)) {
      // remove the filter
      filters[name] = filters[name].filter(function(item) {
        return item !== value
      })
    } else {
      filters[name].push(value)
    }

    var filterCount = filters[name].length;

    $selectedTextCount.text(filterCount);

    if (filterCount) {
      $selectedText.show()
    } else {
      $selectedText.hide()
    }

    filterProducts()

    if (name === "color") {
      // select swatches with that color
      preselectSwatch(value);
    }
  }

  var resetFilters = function(e){
    $(settings.filterInputs + ":checked").click();
  }

  var filterProducts = function(){
    if (!filters.material.length && !filters.color.length && !filters.placement.length && !filters.backType.length && !filters.category.length) {
      // No active filters. Show all cards
      $(settings.productCard).addClass('active').show();
    } else {
      $(settings.productCard).each(function(index, card){
        var hasActiveFilter = false;
        var hasActiveMaterial = !filters.material.length;
        var hasActivePlacement = !filters.placement.length;
        var hasActiveBackType = !filters.backType.length;
        var hasActiveCategory = !filters.category.length;
        var hasActiveColor = !filters.color.length;

        var $card = $(card);
        var data = $card.data();
        var cardColors = data.color ? data.color.split("|||") : [];
        // {placement: "earlobe", backType: "butterfly", material: "titanium", color: "Gold|||Silver"}

        if (filters.material.includes(data.material)) {
          hasActiveMaterial = true;
        }

        cardColors.forEach(function(color){
          if (filters.color.includes(color)) {
            hasActiveColor = true;
          }
        })

        if (filters.placement.includes(data.placement)) {
          hasActivePlacement = true;
        }

        if (filters.category.includes(data.category)) {
          hasActiveCategory = true;
        }

        if (filters.backType.includes(data.backType)) {
          hasActiveBackType = true;
        }

        hasActiveFilter = hasActiveMaterial && hasActivePlacement && hasActiveBackType && hasActiveColor && hasActiveCategory;

        if (hasActiveFilter) {
          $card.addClass('active').show();
        } else {
          $card.removeClass('active').hide();
        }
      })
    }

    organizeTestimonialCards();
    // no results  w/ reset button
  }

  var organizeTestimonialCards = function(){
    $testimonialCards.remove();

    $(settings.productCard + ".active").each(function(index, element){
      if (index === 3) {
        $testimonialCards.eq(0).insertAfter(element);
      } else if (index === 9) {
        $testimonialCards.eq(1).insertAfter(element);
      } else if (index === 17) {
        $testimonialCards.eq(2).insertAfter(element);
      } else if (index === 24) {
        $testimonialCards.eq(3).insertAfter(element);
      }
    })
  }

  var handleCollectionSort = function(e){
    e.preventDefault();
    var $this = $(this);
    var sortHandle = $this.data('handle');

    if (sortHandle) {
      var collectionURL = location.pathname + "?view=ajax-cards&sort_by=" + sortHandle;
      var params = {
        url: collectionURL,
        success: function(response){
          $this.addClass('active');
          $(settings.sortOption).not($this).removeClass('active');

          // inject sorted product cards
          var html = $(response);
          $(settings.collectionGrid).html(html);

          // reset testimonial elements
          $testimonialCards = $(settings.testimonialCards);

          // re-apply filters!
          filterProducts();
        }
      }
      $.ajax(params);
    }
  }

  var preselectSwatch = function(colorValue){
    // only iterate through the active cards, they've already been filtered!
    $(settings.productCard + ".active").each(function(index, card){
      var activeSwatch = $(this).find(settings.swatch + '[data-color="' +  colorValue + '"]');

      if (!activeSwatch.length) {
        activeSwatch = $(this).find(settings.swatch + '[data-color="' +  colorValue + '"]');
      }

      activeSwatch.eq(0).click();
    })
  }

  var toggleDescription = function(e){
    e.preventDefault();

    var $fullDescription = $(settings.fullDescription);
    var $shortDescription = $(settings.shortDescription);

    $fullDescription.toggle();
    $shortDescription.toggle();
  }

  var toggleSwatches = function(e){
    e.preventDefault();
    let $trigger = $(e.target);
    let $textSibling = $trigger.siblings();
    let $additionalSwatches = $trigger.parent().siblings(settings.additionalSwatch);
    $additionalSwatches.toggleClass("hidden");
    $trigger.toggleClass("hidden");
    $textSibling.toggleClass("hidden");
  }

  return { init: init }
})()

var productRecommendations = (function(){
  var settings = {
    recommendationSection: ".js-product-recommendations",
    productCardImages: ".js-product-card-images",
    cardSlider: ".js-product-card-slider",
    productCard: ".js-product-card",
    swatch: ".js-variant-swatch"
  }

  var init = function(){
    if (!$(settings.recommendationSection).length) return;
    initializeRecommendations();
  }

  var initializeRecommendations = function(){
    var $productRecommendationsSection = $(settings.recommendationSection);
    var productId = $productRecommendationsSection.data('productId');
    var baseUrl = $productRecommendationsSection.data('baseUrl');
    var limit = $productRecommendationsSection.data('limit');

    // Build request URL
    var requestUrl = baseUrl + "?section_id=product-recommendations&product_id=" + productId + "&limit=" + limit;
    // Create request and submit it using Ajax
    var request = new XMLHttpRequest();

    $.ajax({
      url: requestUrl,
      success: function(response){
        var container = document.createElement("div");
        container.innerHTML = response;

        var newHTML = container.querySelector(settings.recommendationSection).innerHTML;
        $productRecommendationsSection.html(newHTML);

        // initialize slick
        initializeCardSliders();

        $(settings.swatch + ":checked").click();
      },
      error: function(error){
        console.log(error);
      }
    })
  }

  var initializeCardSliders = function(){
    var $slider = $(settings.recommendationSection).find(settings.cardSlider);

    if ($slider.length) {
      // $(window).on('resize', resizeCardHeights);
      // $slider.on("init", resizeCardHeights);

      $slider.not(".slick-initialized").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: true,
        dots: false,
        infinite: false,
        adaptiveHeight: true,
        centerPadding: '2px',
        nextArrow: '.js-recommendation-next',
        prevArrow: '.js-recommendation-prev',
        mobileFirst: true,
        responsive: [
          {
            breakpoint: 1301,
            settings: {
              slidesToShow: 4,
              infinite: false
            }
          },
          {
            breakpoint: 1300,
            settings: {
              slidesToShow: 3,
            }
          },
          {
            breakpoint: 1199,
            settings: {
              slidesToShow: 2
            }
          },
          {
            breakpoint: 480,
            settings: {
              slidesToShow: 1
            }
          }
        ]
      })
    }
  }

  var resizeCardHeights = function(e){
    var $sliders = $(settings.cardSlider);

    $sliders.each(function(index, slider){
      var tallestCardHeight = 0;
      var $currentSlider = $(slider);
      $currentSlider.find(settings.productCard).css({ minHeight: 0 });

      $currentSlider.find(settings.productCard).not(".slick-cloned").each(function(index, card){
        var height = $(card).outerHeight() + 25;

        if (height > tallestCardHeight) {
          tallestCardHeight = height
        }
      })

      $currentSlider.css({ maxHeight: tallestCardHeight + 60 });
      $currentSlider.find(settings.productCard).css({ minHeight: tallestCardHeight });
    })

  }

  return { init: init }
})()

// ===============
// Search
// ===============
var search = (function(){

  var settings = {
    searchContainer: ".js-nav-search",
    searchBar: ".js-search-bar",
    searchIcon: '.js-search',
    searchResultsWrapper: ".js-predictive-search-container",
    searchResults: ".js-predictive-search-results",
    searchURL: "/search/suggest.json?q=<QUERY>&resources[type]=product,article,collection&resources[limit]=10",
    searchTemplate: "#PredictiveSearchTemplate",
    closeSearch: ".js-close-search",
    searchTerm: ".js-search-term",
    productTitlesToSkip: "unavailable"
  }

  var terms = ['hoops', 'huggies', 'charms', 'statement', 'necklace', 'studs']

  var init = function(){
    if ($(settings.searchContainer).length) {
      initializeEventListeners();
    }
  }

  var handleSearchTerms = function(e){
    var code = e.code;
    if (code === "Enter") {
      // Don't submit while someone's typing
      e.preventDefault();
    }

    var $this = $(this);
    var value = $this.val();

    // mirror the value accross the other search bar
    $(settings.searchBar).not($this).val(value).focus();

    if (value) {
      getSearchResults(value);
    }
  }

  function shuffle(array) {
    var currentIndex = array.length,  randomIndex;

    // While there remain elements to shuffle...
    while (0 !== currentIndex) {

      // Pick a remaining element...
      randomIndex = Math.floor(Math.random() * currentIndex);
      currentIndex--;

      // And swap it with the current element.
      [array[currentIndex], array[randomIndex]] = [
        array[randomIndex], array[currentIndex]];
    }

    return array;
  }

  var getSearchResults = function(value){

    var url = settings.searchURL.replace("<QUERY>", value);
    var params = {
      url: url,
      dataType: "json",
      success: function(response){
        addNoScroll();
        renderPredictiveSearch(response, value);
      },
      error: console.log
    }

    $.ajax(params);
  }

  var renderPredictiveSearch = function(response, query){
    if (response && response.resources && response.resources.results) {
      var searchTerms = terms.filter(function(term){
        if (query && query.length > 1) {
          return !term.includes(query) && !term.match(query);
        } else {
          return term;
        }
      })

      var $searchResultsWrapper = $(settings.searchResultsWrapper), $searchResults = $(settings.searchResults), data = {}, source = $(settings.searchTemplate).html(), template = Handlebars.compile(source);

      let filteredProducts = response.resources.results.products.filter(product=> !product.title.toLowerCase().includes(settings.productTitlesToSkip))

      data = {
        hasCollections: !!response.resources.results.collections.length,
        collection: response.resources.results.collections[0],
        hasProducts: !!filteredProducts.length,
        products: filteredProducts.slice(0,4),
        hasArticles: !!response.resources.results.articles.length,
        articles: response.resources.results.articles,
        hasTerms: true,
        terms: shuffle(searchTerms).slice(0,3),
        query: query
      }

      $searchResults.html(template(data));
      $searchResultsWrapper.slideDown(300);
    }
  }

  var resetSearchTerm = function(e){
    e.preventDefault();

    var term = $(this).text();

    $(settings.searchBar).val(term).change();

    getSearchResults(term);
  }

  var closeSearchContainer = function(e){
    var $searchResultsWrapper = $(settings.searchResultsWrapper), $searchResults = $(settings.searchResults)

    $(settings.searchBar).val('');
    $(settings.searchBar).val('').eq(0).focus();
    $searchResultsWrapper.slideUp(300);
    $searchResults.empty();

    if (!isMobile()) {
      removeNoScroll();

    }
  }

  var openSearchBar = function(e){
    e.preventDefault();

    var $searchResultsWrapper = $(settings.searchResultsWrapper);

    $searchResultsWrapper.slideDown(300);

    $(settings.searchBar).focus();
  }

  var initializeEventListeners = function(){
    // throttle
    $(settings.searchBar).on('keyup', $.throttle(200, handleSearchTerms));
    $(settings.closeSearch).on('click', closeSearchContainer);
    $(settings.searchIcon).on('click', openSearchBar);
    $(document).on('click', settings.searchTerm, resetSearchTerm);
  }

  return {
    init: init
  }
})();


var floatingLabels = (function(){
  var settings = {
    labelContainer: ".js-floating-label",
    floatingInput: ".js-floating-input"
  }

  var init = function(){
    if (!$(settings.labelContainer).length) return;

    initializeEventListeners();
  }

  var initializeEventListeners = function(){
    $(settings.floatingInput).on('focus', addFloatToLabel);
    $(settings.floatingInput).on('blur', remmoveFloatFromLabel);

  }

  var addFloatToLabel = function(){
    $(this).parent(settings.labelContainer).addClass("floating");
  }

  var remmoveFloatFromLabel = function(){
    var text = $(this).val();

    if (!text) {
      $(this).parent(settings.labelContainer).removeClass("floating");
    }
  }

  return {
    init: init
  }

})()


// ++++++++++++++++++++++++
// AA: Curate your Ear Page
// ++++++++++++++++++++++++

const curateYourEar = (() => {
  const settings = {
    earContainer: ".js-ear-container",
    curateContainer: ".js-curate-container",
    toneOptionRadio: ".js-tone-radio",
    toneContainer: ".js-tone-container",
    warmthOptionRadio: '.js-warmth-radio',
    lobeRadio: '.js-lobe-radio',
    earSVG: '.js-ear-svg',
    itemSelectContainer: ".js-curate-items-selector",
    itemSelectorTitle: ".js-placement-title",
    itemSelectorToggle: ".js-toggle-items-selector",
    itemSelectorFilters: ".js-filter-items",
    piercingBtn: ".js-piercing-dot",
    earLabels: ".js-ear-region-label",
    piercingImage: ".js-piercing-image",
    instructionOverlay: ".js-instruction-overlay",
    instructionOverlayStep2: ".js-instruction-overlay-2",
    curateItemCards: ".js-curate-item-card",
    curateItemGrid: ".js-curate-product-grid",
    removeItem: ".js-curate-product-remove",
    curateItemRenderer: ".js-curate-item-renderer",
    curateAddToCart: ".js-curate-add-to-cart",
    upsellAddItem: ".js-curate-add-upsell-item",
    curateLineItem: ".js-curate-line-item",
    curateItemSwap: ".js-curate-swap",
    curateItemRemove: ".js-curate-remove",
    curateItemQuantity: ".js-curate-item-qty",
    curateItemQuantityBtn: ".js-adjust-curate-qty",
    curateSwatch: ".js-curate-swatch",
    togglePiercingsBtn: ".js-toggle-piercings",
    toggleSettingsBtn: ".js-toggle-settings",
    settingsContainer: ".js-settings-container",
    swatch: ".js-custom-swatch",
    additionalSwatch: ".js-additional-swatch",
    toggleSwatches: ".js-toggle-additional-swatches",
    swatchExpandText: ".js-expand-swatches",
    swatchHideText: ".js-hide-swatches",
    addToEar: ".js-add-to-ear",
    swatchParents: ".js-swatch-parent"
  }

  let activeFilter = "All";
  let placement = "earlobe";
  let earringBackProduct = {}
  let items = {}

  // items is key value pairs => {placement: product}
  // {"lobe-1" : {}}

  const init = () => {
    if (!$(settings.earContainer).length) return;
    initializeEventListeners();
    getAllEarringCards();
    getEarringBackProduct();

    renderActiveItems()
  }

  const initializeEventListeners = () => {
    // Ear Settings
    $(settings.toneOptionRadio).on('change', changeSelectedSkinTone);
    $(settings.warmthOptionRadio).on('change', changeSelectedWarmth);
    $(settings.lobeRadio).on('change', changeSelectedEarlobe);
    $(settings.togglePiercingsBtn).on('click', togglePiercingBtns);
    $(settings.toggleSettingsBtn).on('click', toggleSettingsContainer);

    // Open / Close Item Container + Filter Items
    $(settings.piercingBtn).on('click', openItemSelectContainer);
    $(settings.itemSelectorToggle).on('click', closeItemSelectContainer);
    $(settings.itemSelectorFilters).on('click', filterItemSelectOptions);

    // Curate Item Selector Container. Add, remove, add all to cart
    $(document).on('click', settings.addToEar, handleProductAdd);
    $(document).on('click', settings.removeItem, handleProductRemove);
    $(document).on('click', settings.curateAddToCart, addProductsToCart);
    $(document).on('click', settings.upsellAddItem, handleUpsellAdd);

    // hover states for line item and corresponding piercing
    $(document).on('mouseenter focusin', settings.curateLineItem, handleLineItemEnter);
    $(document).on('mouseleave focusout', settings.curateLineItem, handleLineItemLeave);
    $(document).on('mouseenter  focusin', settings.piercingBtn + ".has-piercing", handlePiercingBtnEnter);
    $(document).on('mouseleave focusout', settings.piercingBtn + ".has-piercing", handlePiercingBtnLeave);

    // Line item actions
    $(document).on('change', settings.curateItemQuantity, handleLineItemQtyChange);
    $(document).on('click', settings.curateItemQuantityBtn, adjustItemQuantity);
    $(document).on('click', settings.curateItemSwap, swapLineItem);
    $(document).on('click', settings.curateItemRemove, removeLineItem);
    $(document).on('change', settings.curateSwatch, handleLineItemVariantChange);
    // $(document).on('change', settings.curateItemCards + ' .js-swatch-parent.active .js-es-custom-swatch' , handleActiveCardVariantChange);
    $(document).on('change', settings.curateItemCards + ' .js-es-custom-swatch' , handleCardVariantChange);
    $(document).on('click', settings.toggleSwatches, toggleSwatches);
  }

  const toggleSwatches = function(e){
    e.preventDefault();
    let $trigger = $(e.target);
    let $textSibling = $trigger.siblings();
    let $additionalSwatches = $trigger.parent().siblings(settings.additionalSwatch);
    $additionalSwatches.toggleClass("hidden");
    $trigger.toggleClass("hidden");
    $textSibling.toggleClass("hidden");
  }

  const renderActiveItems = () => {
    let activeItems = sessionStorage.getItem('activeItems');

    if (activeItems) {
      items = JSON.parse(activeItems);

      let itemsLength = getItemsCount();

      if (itemsLength) {
        renderItems();
        $(settings.instructionOverlay).fadeOut(300);
        $(settings.togglePiercingsBtn).fadeIn(300);
        $(settings.toggleSettingsBtn).fadeIn(300);
        $(settings.settingsContainer).addClass('hidden').addClass('border-top');

        if (itemsLength === 1) {
          $(settings.instructionOverlayStep2).removeClass('hide').fadeIn(300);
        }
      }
    }
  }

  const getItemsCount = function(){
    return Object.keys(items).length;
  }

  const slickMobileItems = function(placement){
    let slickSettings = {
      arrows: false,
      autoplay: false,
      dots: false,
      mobileFirst: true,
      slidesToScroll: 1,
      slidesToShow: 1,
      centerMode: true,
      centerPadding: '90px',
      responsive: [
       {
          breakpoint: 9999,
          settings: "unslick"
       },
       {
          breakpoint: 767,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1
          }
        }
      ]
    }

    let $slider = $(settings.curateItemGrid);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('slickUnfilter');
      $slider.slick('unslick');
      $slider.off('afterChange');
    }    

    if (screen.availWidth < 500) {

      $slider.on('afterChange', selectActiveCard);
      $slider.slick(slickSettings);

      filterItemCards();

      if (placement && items[placement]) {
        let product = items[placement].product;

        let $activeSlide = $slider.find('[data-handle="' + product.handle + '"]').not('.slick-cloned');

        $slider.slick('slickGoTo', $activeSlide.data('slickIndex'), true);
      } else {
        $slider.find('[data-slick-index="0"]').click();
      }
    } else {
      filterItemCards();
    }
  }

  const selectActiveCard = function(event, slick, currentSlide){
    // let $activeCard = $(slick.$slides).closest('.slick-current');
    // handleProductAddFromSlider($activeCard);
  }

  const getEarringBackProduct = async () => {
    let productURL = '/products/spare-titanium-earring-backs.json'
    let response = await $.ajax(productURL);
    if (response && response.product) {
      earringBackProduct = response.product;

      renderItems()
    }
  }

  const getAllEarringCards = async () => {
    const collection = $(settings.curateContainer).data('collection');
    let cardHtml = ""
    let page = 1;

    while (page < 20) {

      let collectionUrl = '/collections/' + collection + "?view=curate-cards&page=" + page.toString();

      let response = await $.ajax(collectionUrl);
      
      if (response) {
        if (!response.trim()) {
          page = 25;
        } else {
          cardHtml += response.trim();
          page++
        }
      }
    }

    $(settings.curateItemGrid).html(cardHtml);
  }

  const togglePiercingBtns = function(e){
    let $this = $(this);
    $(settings.piercingBtn).toggleClass("toggle--hide");
    $(settings.earLabels).toggleClass("hide");

    if ($this.hasClass('toggle--show')) {
      $this.removeClass('toggle--show');
      $this.find('.js-toggle-text').text("Hide");
    } else {
      $this.addClass('toggle--show');
      $this.find('.js-toggle-text').text("Show");
    }
  }

  const toggleSettingsContainer = function(e){
    $(settings.settingsContainer).toggleClass('hidden');
  }

  const changeSelectedSkinTone = function(e){
    let $this = $(this);
    let value = $this.val();
    let outlines = $this.data('outlines');
    let outlineClass = "outline--" + outlines;

    $(settings.earContainer).css({ backgroundColor: value }).removeClass('outline--light outline--mid outline--dark').addClass(outlineClass);
  }

  const changeSelectedEarlobe = function(e){
    let $this = $(this);
    let value = $this.val();

    let $activeSVG = $(settings.earSVG + '[data-lobe="'+value+'"]');

    $(settings.earSVG).not($activeSVG).hide();
    $activeSVG.show();

    $(settings.curateContainer).removeClass("attached detached").addClass(value);
  }

  const changeSelectedWarmth = function(e){
    let $this = $(this);
    let value = $this.val();

    // Hide Show Tone List
    const $toneContainers = $(settings.toneContainer);
    const $activeToneContainer = $toneContainers.closest('[data-tone="' + value + '"]');
    $toneContainers.not($activeToneContainer).hide();
    $activeToneContainer.show();

    // Select New Tone
    const $selectedTone = $(settings.toneOptionRadio + ":checked");
    const $selectedParent = $selectedTone.parent('.skin-tone--swatch');
    const position = $selectedParent.index();

    const $newTone = $activeToneContainer.find('.skin-tone--swatch').eq(position).find(settings.toneOptionRadio);

    $newTone.click();
  }

  const openItemSelectContainer = function(e){
    const $this = $(this);
    let title = $this.data('title');
    placement = $this.data('placement');

    const $itemSelectContainer = $(settings.itemSelectContainer);
    const $itemSelectTitle = $(settings.itemSelectorTitle);

    const $otherButtons = $(settings.piercingBtn).not($this)
    $itemSelectTitle.text(title);

    $otherButtons.removeClass('active');
    $this.addClass('active');

    let id = $this.attr('id');

    $itemSelectContainer.show();
    $itemSelectContainer.attr('data-active-piercing', id);

    slickMobileItems(id);

    $(settings.curateItemCards).removeClass('active');

    if (items && items[id]) {
      let activeHandle = items[id].product.handle;
      let $activeCard = $(settings.curateItemCards + '[data-handle="' + activeHandle + '"]')
      $activeCard.addClass('active');
      let currentVariantId = items[id].currentVariant;

      $activeCard.find('.variant--swatch[data-variant="' + currentVariantId + '"] input').click();
    }

    $(settings.earContainer).addClass('sidebar--open');
    $(settings.instructionOverlay).fadeOut(300);
    $(settings.instructionOverlayStep2).fadeOut(300);
    $(settings.togglePiercingsBtn).fadeIn(300);
    $(settings.toggleSettingsBtn).fadeIn(300);
    $(settings.settingsContainer).addClass('hidden').addClass('border-top');

    $(document).trigger('earstack:open')
  }

  const closeItemSelectContainer = function(e){
    const $itemSelectContainer = $(settings.itemSelectContainer);
    $(settings.piercingBtn).removeClass('active');

    $itemSelectContainer.hide();
    $(settings.earContainer).removeClass('sidebar--open');

    let itemsLength = getItemsCount();

    if (itemsLength === 1) {
      $(settings.instructionOverlayStep2).fadeIn(300).removeClass('hide');
    }
  }

  const filterItemSelectOptions = function(e){
    const $this = $(this);
    let value = $this.data('value');

    const $otherItemSelectOptions = $(settings.itemSelectorFilters).not($this).removeClass('active');
    $this.addClass('active');

    activeFilter = value;
    filterItemCards();
  }

  const positionExclusions = {
    "rook-1": ["Stud Earrings", "mini-trendsetter-hoops"],
    "daith-1": ["Stud Earrings", "mini-trendsetter-hoops"],
    "flat-1": ["Huggies", "Hoop Earrings"],
    "conch-4": ["Huggies", "Hoop Earrings", "ellie-studs"],
    "earhead-1": ["Stud Earrings", "mini-trendsetter-hoops"],
    "tragus-1": ["mini-trendsetter-hoops"],
    "lobe-4": ["esme-studs"]
  }

  const filterItemCards = () => {
    let $container = $(settings.itemSelectContainer);
    let activePiercing = $container.attr('data-active-piercing');
    let exclusions;

    let $filterButtons = $(settings.itemSelectorFilters)

    if (activePiercing && positionExclusions[activePiercing]) {
      exclusions = positionExclusions[activePiercing];
    }

    const filteredCards = $(settings.curateItemCards).filter(function(index, el){
      const $card = $(el);
      const productTypes = $card.data('productType');
      const productHandle = $card.data('handle');
      let productPlacement = $card.data('placement');

      if (!productPlacement) {
        productPlacement = "";
      }
      
      if (activeFilter === "All") {
        if (exclusions) {
          let isIncluded = true;

          exclusions.forEach(exclusion => {
            if (productTypes.includes(exclusion)) {
              isIncluded = false
            } else if (productHandle === exclusion) {
              isIncluded = false;
            }
          })

          return productPlacement.includes(placement) && isIncluded;
        } else {
          return productPlacement.includes(placement);
        }
      } else {
        if (exclusions) {
           let isIncluded = true;

           exclusions.forEach(exclusion => {
             if (productTypes.includes(exclusion)) {
               isIncluded = false
             } else if (productHandle === exclusion) {
               isIncluded = false;
             }
           })

           return productTypes.includes(activeFilter) && productPlacement.includes(placement) && isIncluded;
        } else {
          return productTypes.includes(activeFilter) && productPlacement.includes(placement)
        }
      }
    });

    let $slider = $(settings.curateItemGrid);

    if ($slider.hasClass('slick-initialized')) {
      $slider.slick('slickUnfilter');
      $slider.slick('slickFilter', function(index, el){
        const $card = $(el);
        const productTypes = $card.data('productType');
        const productHandle = $card.data('handle');
        const productPlacement = $card.data('placement');
        let isIncluded = true;

        if (exclusions) {
          exclusions.forEach(exclusion => {
            if (productTypes.includes(exclusion)) {
              isIncluded = false
            } else if (productHandle === exclusion) {
              isIncluded = false;
            }
          })
        }

        if (activeFilter === "All") {
          return productPlacement.includes(placement) && isIncluded;
        } else {
          return productTypes.includes(activeFilter) && productPlacement.includes(placement) && isIncluded;
        }
      });

      $slider.slick('slickGoTo', 0, true);
    } else {
      $(settings.curateItemCards).show();
      $(settings.curateItemCards).not(filteredCards).hide();
    }

    // Hide / Show filter buttons by exclusions

    $filterButtons.parent('li').show();

    if (exclusions) {
      exclusions.forEach(exclusion => {
        $filterButtons.closest('[data-value="' + exclusion + '"]').parent('li').hide();
      })
    }
  }

  const handleProductRemove = function(e){
    e.stopPropagation();
    let $card = $(this).parents(settings.curateItemCards);
    $card.removeClass('active');

    let $container = $(settings.itemSelectContainer);
    let placement = $container.attr('data-active-piercing');
    delete items[placement]
    $("#" + placement ).removeClass('has-piercing');
    $("#" + placement ).find(settings.piercingImage).attr('src', '').addClass('hide').data('product', '').data('size', '');
    renderItems();
  }

  const addProductsToCart = function(e){
    let mappedItems = Object.keys(items).map(key => {
      let item = items[key];

      return {
        quantity: item.quantity,
        id: parseInt(item.currentVariant),
        properties: {
          _earStack: true
        }
      }
    })
    try {
      $.ajax({
        url: "/cart/add.js",
        data: {items: mappedItems },
        success: res => {
          cart.onCartUpdate();
        },
        method: "POST"
      })
    } catch (error){
      console.log(error);
    }
  }

  const handleUpsellAdd = function(e) {
    let $this = $(this);
    let variantId = $this.data('id')

    let data = {
      quantity: 1,
      croppedImage: earringBackProduct.image,
      variantImages: [],
      currentVariant: variantId,
      product: earringBackProduct,
      size: ''
    }

    items['earring-back'] = data;

    renderItems()
  }
/*
  const handleProductAddFromSlider = async function($this) {
    let data = {}
    let product;
    let handle = $this.data('handle');
    let $container = $(settings.itemSelectContainer);
    let placement = $container.attr('data-active-piercing');

    let currentVariantId = $this.find('.js-variant-swatch:checked').val();
    let croppedImage = $this.data('croppedImage');
    let variantImages = $this.data('croppedVariantImages')
    let size = $this.data('size');

    if (variantImages) {
      variantImages = variantImages.split("|||").filter(str => str !== "").map(str => {
        let trimmed = str.trim()
        let json = JSON.parse(str.trim())
        return json
      })
    } else {
      variantImages = []
    }

    if (variantImages) {
      variantImages.forEach(imgObject => {
        if (imgObject.id === parseInt(currentVariantId)) {
          croppedImage = imgObject.cropped_image
        }
      })
    }

    let json = await $.ajax('/products/' + handle + '.json');
    if (json && json.product) {
      product = json.product;
    }

    data = {
      quantity: 1,
      croppedImage: croppedImage,
      variantImages: variantImages,
      currentVariant: currentVariantId,
      product: product,
      size: size
    }

    items[placement] = data;

    $(settings.curateItemCards).removeClass('active');
    $this.addClass('active');
    $(settings.swatchParents).removeClass('active');

    console.log($this);
    let variantTitle;
    if (currentVariantId) {
      let variant = product.variants.find(variant => variant.id === parseInt(currentVariantId));
      if (variant) {
        variantTitle = variant.title.toLowerCase().replace(" ", "-");
      }
    }

    $("#" + placement ).addClass('has-piercing');
    let $piercingImage = $("#" + placement).find(settings.piercingImage);
    $piercingImage.attr('src', croppedImage).removeClass('hide');
    $piercingImage.attr('data-product', handle).attr('data-variant', variantTitle);
    $piercingImage.attr('data-size', size)

    renderItems();
  }
*/

  const handleProductAdd = async function(e){
    let $this = $(this);
    let $target = $(e.target);
    if (!$target.hasClass("js-es-custom-swatch") && !$target.hasClass('swatch')) {
      // ok to add!
      // needs variant id, color, placement, cropped image, title, qty
      let data = {}
      let product;
      let handle = $this.parent().data('handle');
      let $container = $(settings.itemSelectContainer);
      let placement = $container.attr('data-active-piercing');

      // let currentVariantId = $this.parent().find('.js-es-custom-swatch:checked').val();
      let currentVariantId = parseInt($this.parent().find('.js-es-hidden-select').val());

      let croppedImage = $this.parent().data('croppedImage');
      let variantImages = $this.parent().data('croppedVariantImages')
      let size = $this.parent().data('size')

      if (variantImages) {
        variantImages = variantImages.split("|||").filter(str => str !== "").map(str => {
          let trimmed = str.trim()
          let json = JSON.parse(str.trim())
          return json
        })
      } else {
        variantImages = []
      }
      
      let json = await $.ajax('/products/' + handle + '.json');
      if (json && json.product) {
        product = json.product;
      }

      $(settings.curateItemCards).removeClass('active');
      $this.parents('.js-curate-item-card').addClass('active');
      
      $(settings.swatchParents).removeClass('active');
      let $parent = $this.siblings('form').children().find(settings.swatchParents);
      $parent.addClass('active');

      let variantTitle;
      if (currentVariantId) {
        let variant = product.variants.find(variant => variant.id === parseInt(currentVariantId));
        if (variant) {
          variantTitle = variant.title.toLowerCase().replace(" ", "-");
        }
      }

      if (variantImages && variantImages.length) {
        variantImages.forEach(imgObject => {
          if (imgObject.id === parseInt(currentVariantId)) {
            croppedImage = imgObject.cropped_image
          }
        })
      }

      data = {
        quantity: 1,
        croppedImage: croppedImage,
        variantImages: variantImages,
        currentVariant: currentVariantId,
        product: product,
        variantTitle: variantTitle,
        size: size
      }

      items[placement] = data;

      renderItems();
    } else {
      e.stopPropagation();
    }
  }

  const handleLineItemEnter = function(e){
    let $card = $(this);
    $card.addClass('active');
    let placement = $card.data('placement');
    $("#" + placement).addClass('has-sparkles');
  }

  const handleLineItemLeave = function(e){
    let $card = $(this);
    $card.removeClass('active');
    let placement = $card.data('placement');
    $("#" + placement).removeClass('has-sparkles');
  }

  const handleCardVariantChange = function(e){
    let $this = $(this);

    if($this.parents('.js-swatch-parent').hasClass('active')) {
      handleActiveCardVariantChange($this)
    }
    let $card = $this.parents(settings.curateItemCards);
    let available = $this.data('available');

    $card.attr('disabled', !available);
  }

  const handleActiveCardVariantChange = function($this){
    // let $this = $(this);

    let placement = $(settings.itemSelectContainer).attr('data-active-piercing');

    //let value = $this.val();

    var $selectContainer = $this.parents(".js-es-custom-select");
    var id = $selectContainer.data('for');
    var $hiddenSelect = $("#" + id);

    let value = $hiddenSelect.val();
    //get hidden select val instead

    if (items[placement]) {
      items[placement].currentVariant = value;
      let variant = items[placement].product.variants.find(variant => variant.id === parseInt(value));
      let variantImage = items[placement].variantImages.find(variantImg => variantImg.id === parseInt(value));
      if (variant) {
        let variantTitle = variant.title.toLowerCase().replace(" ", "-");
        items[placement].variantTitle = variantTitle;

        if (variantImage) {
          items[placement].croppedImage = variantImage.cropped_image;
          $("#" + placement).find(settings.piercingImage).attr("data-variant", "");
        } else {
          $("#" + placement).find(settings.piercingImage).attr("data-variant", variantTitle);
        }
      }
    }

    renderItems();
  }

  const handleLineItemVariantChange = function(e){
    let $this = $(this);
    let placement = $this.data('placement');
    let variantId = parseInt($this.parents('.js-es-custom-select').siblings('.js-es-hidden-select').val());
    let variantTitle;

    if (items[placement]) {
      items[placement].currentVariant = variantId;
      let variant = items[placement].product.variants.find(variant => variant.id === parseInt(variantId));
      let variantImage = items[placement].variantImages.find(variantImg => variantImg.id === parseInt(variantId));
      if (variant) {
        variantTitle = variant.title.toLowerCase().replace(" ", "-");
        items[placement].variantTitle = variantTitle;


        if (variantImage) {
          items[placement].croppedImage = variantImage.cropped_image;
          $("#" + placement).find(settings.piercingImage).attr("data-variant", "");
        } else {
          $("#" + placement).find(settings.piercingImage).attr('data-variant', variantTitle);
        }
      }
    }

    renderItems();
  }

  const adjustItemQuantity = function(e){
    let $this = $(this);
    let $input = $this.siblings(settings.curateItemQuantity);
    let newQuantity = parseInt($this.data('qty'));

    if (newQuantity > -1) {
      $input.val(newQuantity).change();
    }
  }

  const handlePiercingBtnEnter = function(e){
    let $this = $(this);
    $this.addClass('has-sparkles');
    let placement = $this.attr('id');

    let $card = $(settings.curateLineItem + '[data-placement="' + placement + '"]');
    $card.addClass('active');
  }

  const handlePiercingBtnLeave = function(e){
    let $this = $(this);
    $this.removeClass('has-sparkles');
    let placement = $this.attr('id');

    let $card = $(settings.curateLineItem + '[data-placement="' + placement + '"]');
    $card.removeClass('active');
  }

  const removeItemAtPlacement = function(placement) {
    delete items[placement];

    let $cards = $(settings.curateItemCards);
    $cards.removeClass('active');

    $("#" + placement ).removeClass('has-piercing');
    $("#" + placement).removeClass('has-sparkles');
    let $piercingImage = $("#" + placement ).find(settings.piercingImage)
    $piercingImage.attr('src', '').addClass('hide')
    $piercingImage.attr('data-product', '').attr('data-variant', '');
    $piercingImage.attr('data-size', '')
  }

  const handleLineItemQtyChange = function(e){
    let $this = $(this);
    let value = parseInt($this.val());

    let placement = $this.data('position');

    if (items[placement]) {
      if (value === 0) {
        removeItemAtPlacement(placement);
      } else {
        items[placement].quantity = value;
      }
      renderItems();
    }
  }

  const swapLineItem = function(e){
    let $this = $(this);
    let placement = $this.data('position');

    $(settings.piercingBtn + "#" + placement).click();
  }

  const removeLineItem = function(e){
    let $this = $(this);
    let placement = $this.data('position');
    removeItemAtPlacement(placement);
    renderItems();
  }

  const renderItems = function(){
    sessionStorage.setItem('activeItems', JSON.stringify(items));
    // Image Piercing Renderer
    // ----------------------

    Object.keys(items).forEach(key => {
      let item = items[key]

      $("#" + key ).addClass('has-piercing');
      let $piercingImage = $("#" + key ).find(settings.piercingImage);
      $piercingImage.attr('src', item.croppedImage).removeClass('hide');
      $piercingImage.attr('data-size', item.size);

      if (item.variantImages && item.variantImages.length) {
        $piercingImage.attr('data-product', item.product.handle).attr('data-variant', '');
      } else {
        $piercingImage.attr('data-product', item.product.handle).attr('data-variant', item.variantTitle);
      }
    })

    // Line Item Renderer
    // ------------------
    let $curateItemRenderer = $(settings.curateItemRenderer)

    let source = $("#CurateItemTemplate").html()
    let template = Handlebars.compile(source);
    let totalPrice = 0;
    let earringBackFormattedPrice, earringBackProductVariantId;
    let earringBacksInList = false;

    let mappedItems = Object.keys(items).map(key => {
      let item = items[key]
      item.position = key
      let currentVariant;
      let itemIsEarringBack = (key === "earring-back");

      if (itemIsEarringBack) {
        earringBacksInList = true
      }

      let variants = item.product.variants.map(variant => {
        let handle = variant.title.toLowerCase().replace(" ", "-");

        let isSelected = variant.id === parseInt(item.currentVariant);
        if (isSelected) {
          currentVariant = variant;
        }
        return {...variant, handle: handle, isSelected: isSelected, position: item.position }
      });

      let mappedOptions = item.product.options.map(option => {
        let valueObjects = option.values.map(value => {
          let isSelected = false;

          if (currentVariant) {
            let optionPositionString = 'option' + (option.position);
            isSelected = (currentVariant[optionPositionString] === value);
          }

          return {
            value: value,
            isSelected:isSelected,
            id: option.id,
            name: option.name,
            position: option.position,
            lobePosition: item.position,
            product_id: option.product_id
          } 
        })
        
        return {...option, valueObjects: valueObjects }
      });

      if (currentVariant) {
        totalPrice += parseInt(currentVariant.price) * 100 * item.quantity;
        item.product.formattedPrice = formatMoney(currentVariant.price, "${{ amount }}");
      }

      item.product.variants = variants;
      item.product.options = mappedOptions;
      item.itemMinus = item.quantity - 1;
      item.itemPlus = item.quantity + 1;
      item.itemIsEarringBack = itemIsEarringBack;
      return item
    })

    if (earringBackProduct.variants) {
      earringBackFormattedPrice =  formatMoney(earringBackProduct.variants[0].price, "${{ amount }}")
      earringBackProductVariantId = earringBackProduct.variants[0].id
    } else {
      earringBacksInList = true;
    }

    let data = {
      items: mappedItems,
      formattedTotal: formatMoney(totalPrice, "${{ amount }}"),
      isEmpty: mappedItems.length === 0,
      earringBacksInList: earringBacksInList,
      earringBackProduct: earringBackProduct,
      earringBackProductVariantId: earringBackProductVariantId,
      earringBackFormattedPrice: earringBackFormattedPrice
    }
    $curateItemRenderer.html(template(data));
    $(document).trigger('handlebars:complete');
    if (mappedItems.length) {
      $(settings.curateAddToCart).text('add to cart').attr('disabled', false)
    } else {
      $(settings.curateAddToCart).text('select a piercing to begin').attr('disabled', true)
    }
  }

  return {
    init
  }
})()

var earStackerCustomSelect = (function(){
  var settings = {
    customSelect: ".js-es-custom-select",
    selectTrigger: ".js-es-custom-trigger",
    selectOption: ".js-es-custom-option",
    hiddenSelect: ".js-es-hidden-select",
    swatch: ".js-es-custom-swatch",
    section: "#shopify-section-product-panel",
    imageSlider: '[data-slider="product-images"]',
    controllerSlider: '[data-slider="product-images-controller"]',
    productImages: "[data-product-image]",
    productCard: '.js-curate-item-card'
  }

  var init = function(){
    initializeEventListeners()
  }

  var initializeEventListeners = function(){
    $(document).on('click', settings.selectTrigger, toggleSelect);
    $(document).on('click', settings.swatch, setActiveOptionFromSwatch);
    $(document).on('handlebars:complete', disableLineItems)
    $(document).on('earstack:open', disableItemCards)

    // $(document).watchForChild($('.curate--items-grid').get(0), ($el) => {
    //  $el.children().each((index, card) => {
    //    relateOptionsToVariants($(card))
    //   })
    // })
  }

  function disableLineItems() {
    $('.js-curate-line-item').each((index, item) => {
      relateOptionsToVariants($(item))
    })
  }
  
  function disableItemCards() {
    $('.js-curate-item-card').each((index, item) => {
      relateOptionsToVariants($(item))
    })
  }

  function getProduct(pid) {
    let collection = JSON.parse($("#Collection-JSON").text())
    let currentProduct = {};
    collection.forEach((product) => {
      if (product.id === pid) {
        currentProduct = product;
        return;
      };
    })
    return currentProduct;
  }

  function relateOptionsToVariants($this) {
    let $cardContainer = $this;
    const $options = $cardContainer.find('[data-component="product-option"]') /* this is the indiv input component */

    const selectedOptions = getSelectedOptions($options)
    const optionTypes = selectedOptions.map((option) => {
      return $options.filter(`[value="${option}"]`).attr('name')
    })
    const allCombinations = generateCombinations($options, optionTypes)
    disableUnavailableOptions($options, allCombinations)

  }

  function getSelectedOptions($options) {
    const $selectedOptions = $options.filter(':checked')

    return $selectedOptions.map((index, element) => $(element).val()).get()
  }

  /**
   * Generates all possible combinations of options.
   * @param {Array} optionTypes - The option types.
   * @returns {Array} - All combinations of options.
   */
  function generateCombinations($options, optionTypes) {
    return optionTypes.reduce((accumulator, currentType) => {
      const $currentOptions = $options.filter(`[name="${currentType}"]`) // removed :not(:checked)
      const otherOptionTypes = optionTypes.filter((item) => item !== currentType)
      const $otherSelectedOptions = $options.filter((index, option) => {
        return otherOptionTypes.includes($(option).attr('name')) && $(option).is(':checked')
      })
      const selectedOptions = $otherSelectedOptions.map((index, option) => $(option).val()).get()
      const combinations = $currentOptions.get().map((option) => {
        return {
          pid: $(option).data('product-id'),
          dynamicOption: $(option).val(),
          ...selectedOptions,
        }
      })

      return [...accumulator, ...combinations]
    }, [])
  }

  function getVariant(selectedOptions, pid) {
    if (!pid) return;
    const product = getProduct(pid)
    if (product && product.variants){
      return product.variants.find(function (variant) {
        if (variant.options.sort().join(',') === selectedOptions.sort().join(',')) {
          return variant
        }
      })
    }
    
  }

  /**
   * Disables options that are not available in any combination.
   * @param {Array} combinations - The combinations of options.
   */
  function disableUnavailableOptions($options, combinations) {
    $options.parent().removeClass('diagonal-strikethrough')
    const $selectedOptions = $options.filter(':checked')
    combinations.forEach((combination) => {
      let combinationValues = (({ pid, ...object }) => object)(combination);
      const variant = getVariant(Object.values(combinationValues), combination.pid)
      if (variant && !variant.available) {
        // console.log($options.filter(`[value="${combination.dynamicOption}"]`))
        $options.filter(`[value="${combination.dynamicOption}"]`).parent().addClass('diagonal-strikethrough')
      } else {
        //console.log(variant);
      }
    })
  }

  var toggleSelect = function(e){
    $(settings.customSelect).toggleClass('open');
  }

  var generateSrcSet = function(imageSrc) {
    const WIDTHS = [180, 360, 470, 600, 770, 970, 1060, 1280, 1512, 1728, 2048];
    const regex = (/\.(gif|jpe?g|tiff?|png|webp|bmp)/)
    const srcset = [];
    let matches = imageSrc.match(regex)

    if (matches) {
      for (let width of WIDTHS) {
        let matchPrefix = "_" + width + "x" + (matches[0]);
        let newSrc = imageSrc.replace(regex, matchPrefix);
        srcset.push(`${newSrc} ${width}w`);
      }
    }

    return srcset.join(',');
  }
  
  var getCurrentVariant = function(selectedVariantId) {
    if (product && product.variants){
      let variantData = product.variants;
      
      let currentVariant = variantData.find((variant) => {
        return variant.id == selectedVariantId
      });

      return currentVariant;
    } else {
      return {};
    }
  } 


  var setActiveOptionFromSwatch = function(e) {
    var $this = $(this);
    var $form = $this.parents('.js-es-variant-form');
    var $selectContainer = $this.parents(settings.customSelect);
    var id = $selectContainer.data('for');
    // var value = $this.data('value');

    var options = $form.find(settings.selectOption + ".active");
    var swatches = $form.find(settings.swatch + ":checked");

    var activeVariantNames = []

    options.each(function(index, opt){
      activeVariantNames.push($(opt).data('value'))
    })
    swatches.each(function(index, swatch){
      activeVariantNames.push(swatch.value)
    })
    

    // data

    var $hiddenSelect = $("#" + id);
    var activeVariantValue;

    $hiddenSelect.find('option').each(function(index, option) {

      var title = $(option).data('title');
      var titles = title.split(" / ");
      var matchedNames = activeVariantNames.filter(function(variantName) {
        return titles.includes(variantName);
      });

      if ( matchedNames.length === activeVariantNames.length ) {
        activeVariantValue = $(option).val();
      }
    });


    if ( activeVariantValue ) {
      $hiddenSelect.val(activeVariantValue).change();
    }
    let $parentCard = $this.parents('.js-curate-item-card, .js-curate-line-item');
    relateOptionsToVariants($parentCard);

  }


  return { init: init }
})();

const addToCartBar = {
  settings: {
    productForm: '.js-product-form',
    stickyATC: '.js-section-atc-bar'
  },

  init: function() {
    const { productForm, stickyATC } = this.settings;

    const $productForm = $(productForm);
    const $stickyATC = $(stickyATC);

    if ( !$productForm.length || !$stickyATC.length ) { return; }

    $(window).on('scroll', function() {
      // Check if productForm is in view
      const pageTop = $(window).scrollTop();
      const formTop = $productForm.offset().top;
      const formHeight = $productForm.height();
      const formInView = (pageTop + (formHeight / 2) < formTop);

      // Check if footer is in view
      const pageBottom = pageTop + $(window).innerHeight();
      const $footer = $('.footer');
      const footerTop = $footer.offset().top;
      const footerInView = (pageBottom > footerTop);

      // Show/hide stickyATC
      if ( formInView || footerInView ) {
        $stickyATC.removeClass('active');

      } else {
        $stickyATC.addClass('active');
      }
    })
  }
};


/**
 * Fixes the placement of the ShopKeep Gift Card Form DOM node
 */

const shopkeepGiftCard = {
  settings: {
    giftCardForm: '#skt-fields',
    variantSelector: '.js-custom-select'
  },

  init: function() {
    const giftCardPDP = window.location.pathname.includes('gift-card');
    if ( !giftCardPDP ) return;

    const { giftCardForm, variantSelector } = shopkeepGiftCard.settings;

    const findSKT = setInterval(() => {
      const $giftCardForm = $(giftCardForm);

      if ( $giftCardForm.length ) {
        clearInterval(findSKT);
        $giftCardForm.detach().insertAfter(variantSelector);
      }
    }, 300);
  }
};


/**
 * Adds zoom-in/zoom-out feature to images
 */

 magnifyProductImage = {
  settings: {
    trigger: {
      class: 'js-magnify',
      selector: '.js-magnify'
    }
  },

  init: function() {
    const { trigger } = magnifyProductImage.settings;
    const $triggers = $(trigger.selector);

    if ( !$triggers.length ) return;

    magnifyProductImage.initEventListeners();
  },

  initEventListeners: function() {
    const { trigger } = magnifyProductImage.settings;
    const $triggers = $(trigger.selector);

    $triggers.on('mousedown', () => magnifyProductImage.ensureClick($triggers));
  },

  ensureClick: function($triggers) { // Make sure click isn't drag
    if ( window.innerWidth < 960 ) return;

    $triggers.on('mouseup mousemove', function handler(e) {
      if ( e.type === 'mouseup' ) {
        magnifyProductImage.toggleMagnify(e);
      }
      $triggers.off('mouseup mousemove', handler);
    });
  },

  toggleMagnify: function(triggerEvent) {
    const $target = $(triggerEvent.currentTarget);
    const isActive = $target.hasClass('active');

    if ( !isActive ) {
      $target.addClass('active');

      $(document).on('mousemove', (e) => magnifyProductImage.followMouse(e, $target));
    }

    if ( isActive ) {
      $target.removeClass('active');

      $(document).off('mousemove')
    }
  },

  followMouse: function(mouseEvent, $target) {
    const mouseX = ( (mouseEvent.pageX - $target.offset().left) / ($target.width()) * 100 ).toFixed(2);
    const mouseY = ( (mouseEvent.pageY - $target.offset().top) / ($target.height()) * 100 ).toFixed(2);

    if ( mouseX < 0 || mouseX > 100 ) return;
    if ( mouseY < 0 || mouseY > 100 ) return;

    $target.css({
      backgroundPosition: `${ mouseX }% ${ mouseY }%`
    });
  }
}
// +++++++++++++++++++++
// JMK: Wishlist Popup 
// +++++++++++++++++++++
const wishlist = {
  settings: {
    heartIcon: '.js-wishlist-heart',
    popupContainer: '.js-nav-wishlist',
    activeClass: "active",
    overlay: '.js-overlay',
    wishlistContainer: '.js-nav-wishlist-items',
    wishlistItem: '.nav-wishlist-item',
    wishlistItemImg: '.nav-wishlist-item-img',
    wishlistItemTitle: '.nav-wishlist-item-title',
    wishlistItemPrice: '.nav-wishlist-item-price',
    wishlistCount: '.nav-wishlist-count',
    clone: '.clone',
    original: '.original',
    wishlistRemove: '.fave-page-unfave',
    navWishlistATC: '.nav-wishlist-atc',
    navWishlistATCId: '.nav-wishlist-atc-input',
    navWishlistQuickshopImg: '.nav-wishlist-quickshop-img',
    emptyWishlist: '.js-empty-wishlist',
    loadingWishlist: ".js-loading-wishlist",
    productAddToWishlist: ".ssw-icon-heart-o .ssw-fave-icon",
    productRemoveFromWishlist: ".ssw-icon-heart .ssw-fave-icon",
    wishlistClose: ".js-nav-wishlist-close"
  },
  wishlistItems: {},

  init: function() {
    this.initEventListeners();
    // this.initWishlist();
    this.watchForWishlistUpdate();
  },
  initWishlist: function() {
    this.wishlistLoading();
    const getFaves = () => {
      if (Ssw && !Ssw.Fave && Ssw.wishlist && Ssw.wishlist.instance) {
        //initalize "Fave" object, used to only init on clicking the side tab
        Ssw.wishlist.instance._wishlistAssetsLoader.loadMain().then((function() {
          Ssw.Fave.init( Ssw.wishlist.instance._wishlistOptionsManager.options)
        }));
      } 
      if (Ssw && Ssw.Fave && Ssw.Fave.wishlistListsManager) {
        Ssw.Fave.wishlistListsManager.getFavesList((res) => {
          clearInterval(myInterval);
          this.wishlistItems = res.faves;
          this.resetWishlist();
          this.buildWishlist(this.wishlistItems);
        })
      }
    }
    let myInterval = setInterval(getFaves, 500)
  },
  initEventListeners: function() {
    const { heartIcon, overlay, wishlistClose } = this.settings;

    $(heartIcon).on('click', (e) => this.handleClick(e));
   
    $(overlay).on('click', (e) => this.closePopupIfOpen());
    $(wishlistClose).on('click', (e) => this.closePopupIfOpen());
  },
  closePopupIfOpen: function() {
    let $popup = $(this.settings.popupContainer);
    if (this.isPopupOpen($popup)) this.closePopup($popup);
  },
  watchForWishlistUpdate: function () {
    $(document).watchFor('.ssw-product-cart-added', ($el) => {
      $el.each((index, button) => {
       $(button).text("").append('<i class="ssw-icon-check"></i>');
    })
  })
      // to watch for updates like add/delete 
    $(document).watchFor('.ssw-fave-list-container', ($el) => {
      $el.each((index, container) => {
        this.wishlistLoading();
        let $container = $(container);
        $(document).watchForChild($container.get(0), () => {
          setTimeout(() => {
            if (Ssw && Ssw.Fave && Ssw.Fave.wishlistListsManager) {
              Ssw.Fave.wishlistListsManager.getFavesList((res) => {
                this.wishlistItems = res.faves;
                this.resetWishlist();
                this.buildWishlist(this.wishlistItems);
              })
            }
          }, 500);

        })
      })
    })
  },
  buildWishlist: function(faves) {
    let flag = false;
    let counter = Object.keys(faves).length;
    for (let key in faves){
      let v = faves[key];
      let qsUrl = `/products/${v.handle}?view=quickshop`
        if(!flag) {
          flag = true;
          // break up into groups and comment what's happening
          $(this.settings.emptyWishlist).css("display", "none");
          $(this.settings.loadingWishlist).css("display", "none");
          $(this.settings.wishlistContainer).css("display", "block");
          $(this.settings.wishlistItem).css("display", "flex");
          $(this.settings.original).find('form').attr('id', `ATC-form-${v.id}`);
          $(this.settings.wishlistItemTitle).text(v.title);
          $(this.settings.wishlistItemPrice).text(v.price);
          $(this.settings.wishlistItemImg).attr('src', v.image_url);
          $(this.settings.wishlistItemImg).attr('alt', v.title);
          $(this.settings.navWishlistATCId).attr('value', v.id);
          $(this.settings.navWishlistQuickshopImg).attr('data-url', qsUrl);
          $(this.settings.navWishlistATC).attr('data-url', qsUrl);
        } else {
          let $cloneItem = $(this.settings.original).first().clone();
          $cloneItem.find(this.settings.wishlistItem).css("display", "flex");
          $cloneItem.find('form').attr('id', `ATC-form-${v.id}`)
          $cloneItem.find(this.settings.wishlistItemTitle).text(v.title);
          $cloneItem.find(this.settings.wishlistItemPrice).text(v.price);
          $cloneItem.find(this.settings.wishlistItemImg).attr('src', v.image_url);
          $cloneItem.find(this.settings.wishlistItemImg).attr('alt', v.title);
          $cloneItem.find(this.settings.navWishlistATCId).attr('value', v.id);
          $cloneItem.find(this.settings.navWishlistQuickshopImg).attr('data-url', qsUrl);
          $cloneItem.find(this.settings.navWishlistATC).attr('data-url', qsUrl);

          $cloneItem.addClass("clone");
          $cloneItem.removeClass("original");
          $(this.settings.wishlistContainer).append($cloneItem);
        }
      }
   if (counter === 0) {
    $(this.settings.original).css("display", "none")
    $(this.settings.emptyWishlist).css("display", "flex");
    $(this.settings.loadingWishlist).css("display", "none");
    $(this.settings.heartIcon).removeClass([this.settings.activeClass]);
   } else if (counter >= 1) {
    $(this.settings.heartIcon).addClass([this.settings.activeClass]);
   }
   $(this.settings.wishlistCount).html(`<span>${counter}</span>`);
  },
  resetWishlist: function() {
    $(this.settings.clone).remove();
  },
  wishlistLoading: function() {
    $(this.settings.emptyWishlist).css("display", "none");
    $(this.settings.loadingWishlist).css("display", "flex");
  },
  handleClick: function(e) {
    e.preventDefault();
    let $popup = $(this.settings.popupContainer);
    if ( $popup ) {
      if ( !this.isPopupOpen($popup) ) {
        this.openPopup($popup);
      } else {
        this.closePopup($popup);
      }
    }
  },
  isPopupOpen: function($popup) {
    return $popup.hasClass('active');
  },
  openPopup: function($popup) {
    const overlay = $(this.settings.overlay).not(".js-mega-menu .js-overlay");
    overlay.css({
      "top": "0",
      "z-index": "3"
    });
    overlay.addClass([this.settings.activeClass, "wishlist-overlay"]);
    $popup.addClass('active');
    addNoScroll();

    //this.addTabindex($popup);
  },

  closePopup: function($popup) {
    $popup.removeClass('active');
    removeNoScroll();

    var overlay = $(this.settings.overlay);
    if (overlay.hasClass("cart-overlay")) {
      overlay.removeClass(["wishlist-overlay"]);
    } else {
      overlay.removeClass([this.settings.activeClass, "wishlist-overlay"]);
    }

    //this.removeTabindex($popup);
  },
  /* addTabindex: function($menu) {
    $menu.find('> ul > li > a').each(function() {
      $(this).attr('tabindex', '0');
    });
  },

  removeTabindex: function($menu) {
    $menu.find('a').each(function() {
      $(this).attr('tabindex', '-1');
    });
  }*/
}

// +++++++++++++++++++++
// JMK: Reward Page
// +++++++++++++++++++++

  const rewards = {
    settings: {
      rewardRuleBox: ".ssw-reward-page-spending-rule",
      earningRuleBox: ".ssw-reward-page-earning-rule",
      rewardBoxesWrapper: ".ssw-reward-page-spending-rules-wrapper",
      earningBoxesWrapper: ".ssw-reward-page-earning-rules-wrapper",
      rewardBoxes: ".ssw-reward-page-spending-rules",
      earningBoxes: ".ssw-reward-page-earning-rules",
      variantTitle: ".ssw-reward-page-srule-discount-title:contains('(')",
      referFriendBox: "#ssw-reward-page-refer-friend",
      vipTiersBox: ".ssw-reward-page-viptiers-item",
      tiersPageBox: ".ssw-reward-page-tier"
    },  
    init: function() {
      this.watchForGrowaveElements();
    },
    watchForGrowaveElements: function() {
      const { rewardRuleBox, rewardBoxesWrapper, rewardBoxes, variantTitle, earningBoxesWrapper, earningRuleBox, referFriendBox, vipTiersBox, earningBoxes } = this.settings;
  
      $(document).watchFor(rewardRuleBox, ($el) => {
        $el.each((index, box) => {
         $(box).removeClass("ssw-hide");
        })
      })
      $(document).watchFor(rewardBoxesWrapper, ($el) => {
        $el.each((index, wrapper) => {
         $(wrapper).children(rewardBoxes).removeClass("ssw-reward-page-spending-rules-4").addClass("ssw-reward-page-spending-rules-3")
         let $variantTitle = $(wrapper).find(variantTitle);
         $(wrapper).find(".ssw-reward-btn-earn").each((index, btn) => {
          if ($(btn).text() == "Earn Tini Points") $(btn).text("Earn");
         })
        $variantTitle.each((index, t) => {
          let newText = $(t).text().replace(/ *\([^)]*\) */g, ""); // remove variant details from title
          $(t).text(newText);
         })

         let $viewMore = $(wrapper).children(".ssw-text-center");
         if ($viewMore.text().trim() == "view more") {
            $viewMore.addClass("ssw-hide")
          }
        })
      })

      $(document).watchFor(earningBoxesWrapper, ($el) => {
        $el.each((index, wrapper) => {
          $(wrapper).children(earningBoxes).removeClass("ssw-reward-page-earning-rules-4").addClass("ssw-reward-page-earning-rules-3")
          $(wrapper).find(earningRuleBox).each((index, box) => {
            $(box).removeClass("ssw-hide");
          })
         let $viewMore = $(wrapper).children(".ssw-text-center");       
         if ($viewMore.text().trim() == "view more") {
            $viewMore.addClass("ssw-hide")
          }
        })
      })

      $(document).watchFor(referFriendBox, ($el) => {
        $el.each((index, box) => {
          $(".ssw-reward-friend-desc").append(":")
          let $percentOff = $(".ssw-reward-box-discount-info-item-text")
          $percentOff.each((index, item) => {
            let newText = $(item).text().replace('-', '');
            $(item).text(newText);
          })
          
        })
      })

      $(document).watchFor(vipTiersBox, ($el) => {
        $el.each((index, box) => {
          let $box = $(box);

          let $status = $box.find(".ssw-reward-page-viptiers-item__status")
          let newText = $status.html().replace(':', ':<br/>');
          $status.html(newText);

          let $price = $box.find(".ssw-reward-page-viptiers-item__substatus span").text();
          $box.find(".ssw-reward-page-viptiers-item__bottom-subitem-title").each((index, item) => {
            let $item = $(item)
            if ($item.text().trim() == "Multiplier") {
              $item.text("Spend");
              $item.siblings(".ssw-reward-page-viptiers-item__bottom-subitem-info").text($price)
            } else if ($item.text().trim() == "Bonus") {
              $item.text("Receive");
              let $info = $item.siblings(".ssw-reward-page-viptiers-item__bottom-subitem-info")
              let newText = $info.text().replace(' off discount', '');
              $info.text(newText)
            }
          })
        })
      })

      $(document).watchFor(".ssw-reward-tier-modal", ($el) => {
        $el.each((index, box) => {
          $(box).find(".ssw-reward-box-text").each((index, item) => {
            let $item = $(item)
              if ($item.text().includes('Spend')) {
                let newText = $item.html().replace('Spend', 'Spend:');
                $item.html(newText);
                $item.addClass('pre-colon')
              } else if ($item.text().includes('Benefits')) {
                let newText = $item.text().replace('Benefits you will get:', 'Benefits:');
                $item.text(newText);
                $item.addClass('pre-colon')
                let $firstSibling = $($item.siblings()[0])
                if ($firstSibling) {
                  let siblingText = `<span>${$firstSibling.text()}</span>`
                  $item.append(siblingText);
                  $firstSibling.remove();
                }
              }
          })
          
        })
      })
      
    }
  }
// +++++++++++++++++++++
// Initialize all custom JS modules here
// +++++++++++++++++++++
var init = function() {
  accessibility.init();
  accordion.init();
  account.init();
  addToCartBar.init();
  animations.init();
  cart.init();
  checkBrowser.init();
  checkOS.init();
  collection.init();
  if (location.pathname.includes('curate-your-ear')) {
    curateYourEar.init();
    earStackerCustomSelect.init();
  }
  productRecommendations.init();

  $(document).watchFor('.js-has-custom-select', function($el) {
    $el.each(function(index, el) {
      customSelect(el);
    })
  })

  // customSelect.init();
  singlePairSelector.init();
  floatingLabels.init();
  footer.init();
  indexCategories.init();
  indexTestimonials.init();
  inlineVideo.init();
  journeyRange.init();
  marquee.init();
  megamenu.init();
  navigation.init();
  popupGenerator.init();
  productPage.init();
  quickShop.init();
  search.init();
  slickSliders.init();
  shopkeepGiftCard.init();
  magnifyProductImage.init();
  wishlist.init();
  rewards.init();
}

jQuery(init);
